export default {
  serviceCenter: {
  abilityAbove07KnowledgePointCount: 'Knowledge points with ability > 0.7',
  abilityAtLeast085KnowledgePointCount: 'Knowledge points with ability ≥ 0.85',
  abilityAtMost07KnowledgePointCount: 'Knowledge points with ability ≤ 0.7',
  abilityAtMost085KnowledgePointCount: 'Knowledge points with ability ≤ 0.85',
  abilityImprovement: 'Ability improvement',
  account: 'Adaptive Account',
    accountActivateDate: 'Account Activate Date:',
  accountActivateTime: 'Account Activate Time',
  accountBindDate: 'Account Bind Date',
  accountBindLimitExceeded: 'Machine cannot bind more accounts. Please unbind first.',
  accountBindPhone: 'Account Bind Phone',
  accountBindTime: 'Account Bind Time',
  accountCannotSubscribe: 'Account cannot subscribe. Please wait for HQ approval.',
  accountFaceUnbind: 'This account was unbound due to face verification. Cannot continue.',
    accountFreeze: 'Freeze Account',
  accountLabel: 'Account',
  accountNotExist: 'Account does not exist',
  accountPausedCannotSubscribe: 'Account is paused. Please unbind extra accounts in Parent App or apply for limit increase.',
  accountPhoneRebind: 'Account Phone Rebind',
  accountRequired: 'Account is required',
  accountStatusLabel: 'Account Status:',
  accountType: 'Account Type',
  accountUnbind: 'Account Unbind',
  accountUnbindPhoneTip: 'This account has no bound phone. Please bind phone first to change service center.',
    accountUnfreeze: 'Unfreeze Account',
  accountUser: 'User Account',
  activate: 'Activate',
  activeStudentCount: 'Active Students',
  activityEndTime: 'Activity end time',
  activityStartTime: 'Activity start time',
  activitySubject: 'Activity subject',
  adaptiveAccount: 'Adaptive Account:',
  adaptiveAccountColon: 'Adaptive Account:',
  adaptiveAccountText: 'Adaptive Account',
  addSuccess: 'Added successfully',
  agent: 'Agent ID',
    agentId: 'Agent ID',
    agentIdLabel: 'Agent ID:',
  agentLabel: 'Agent',
  agentName: 'Agent Name',
    agentNameLabel: 'Agent Name:',
  all: 'All',
  already: 'Activated',
  analystName: 'Analyst Name',
  analystReviewExport: 'Analyst Review Export',
  analystReviewer1: 'Reviewer',
  analystReviewSyncCourseStudyLength: 'Sync course study duration',
  applicationLengthTip: 'Enter 2-50 characters',
  applicationNote: 'Application Note',
  applicationNoteLabel: 'Application Note:',
    applyAccountSubscriptionAuth: 'Apply Account Subscription Auth',
    applyAuth: 'Apply Auth',
    applyAuthConfirmTip: 'After confirmation, authorization request will be sent to Parent App.',
  applyCheckFailed: 'Pre-application validation failed',
  applyElectronicCert: 'Apply for E-Certificate',
  applyPaperCert: 'Apply for Paper Certificate',
  applySuccess: 'Application successful',
  applyTime: 'Apply Time:',
  applyTipText: 'Only unapplied students are shown. Applied or payment-in-progress students are hidden. For orders in payment, go to Purchase Center - Online Orders.',
  applyTransferServiceCenter: 'Apply Transfer to Service Center',
  applyTransferSuccessTip: 'User {name} ({account}) has submitted transfer application.<br /><br />Please ask parent to confirm in Squirrel AI Parent App. If not confirmed within 7 days, transfer will fail.',
  areaBalance: 'Area Duration Balance',
    areaBalanceLabel: 'Area Duration (Gift/Renewal) Balance:',
  areaBalanceLabelShort: 'Area Duration:',
    areaBalanceMonthLabel: 'Area Duration (Gift/Renewal) Months:',
    areaBalanceMonthsLabel: 'Area Duration (Gift/Renewal) Months:',
  areaDurationBalanceLabel: 'Area Duration Balance:',
  audit: 'Auditor',
  balance: 'Area Duration (Gift/Renewal) Balance',
  batchAssignServicePerson: 'Batch Assign Service Person',
  bayear: 'Grade 8',
  bgImageLoading: 'Background image loading, please wait',
    bindConfirmTip1: '1. Student {name} ({account}) is already bound to another machine account.',
    bindConfirmTip2: '2. Confirm to rebind student {name} ({account}) to current machine account?',
    bindConfirmTip3: '3. After rebind, subscribed subjects ({subjects}) will be unsubscribed, and deducted duration will not be refunded.',
  bindFailed: 'Bind failed',
  bindStudentAccount: 'Bind Student Account',
  bindSuccess: 'Bind successful',
  byAnalyst: 'By Analyst',
  byGrade: 'By Grade',
  callDuration: 'Call Duration',
  callEndTime: 'Call End Time',
  callStaff: 'Call Staff',
  callStaffAccount: 'Call Staff Account',
  callStaffName: 'Call Staff Name',
  callStartTime: 'Call Start Time',
  callTime: 'Call Time',
  videoCallFollowPeopleLabel: 'Personnel',
  videoCallFollowPeoplePlaceholder: 'Please select personnel',
  videoCallDialingTimeLabel: 'Dialing Time',
  campus: 'Campus',
  campusName: 'Campus Name',
  cancelFailed: 'Cancel failed',
  cancelOrderConfirmText: 'Confirm to cancel this order? Once cancelled, the paid amount will be refunded to the corresponding agent account and the futures order quota will be adjusted.',
    cancelSubscribe: 'Cancel Unsubscribe',
  cancelSuccess: 'Cancelled successfully',
    cannotUnbindNotExceedLimit: 'Cannot unbind. Account bind limit not exceeded.',
  caozuo: 'Operator',
  certAreaMismatchTip: 'New cert area does not match common area.<br/>After modification, gift subscription duration cannot be used this month. Confirm to modify?',
    certAreaNotExist: 'Machine account cert area not set. Please complete cert area first.',
  changeType: 'Change Type',
  changeTypeActivate: 'Activate',
  changeTypeChangeArea: 'Change Area',
  changeTypeExtraGift: 'Extra Gift',
  changeTypeGift: 'Gift',
  changeTypeGiftRenew: 'Gift Renew',
  changeTypeOnePersonOneReturn: 'One Person One Return',
  changeTypeOpenSubscribe: 'Open Subscribe',
  changeTypeRenew: 'Renew',
  changeTypeSubscribe: 'Subscribe',
  changeTypeWrongReturn: 'Wrong Subscribe Return',
    checkFaceChangeLearningMachine_1: 'Request parameters cannot be empty',
    checkFaceChangeLearningMachine_2: 'Change too frequent, cannot change account phone number',
    checkFaceChangeLearningMachine_3: 'Only learning machines with verified accounts can change phone number. Please complete face verification first.',
    checkFaceChangeLearningMachine_networkError: 'Network error, please try again later',
  chuangjian: 'Creator',
  ci: 'Next Follow',
  cityLevel: 'City Level',
  cityLevelLabel: 'City Level:',
  clearFilter: 'Clear filter',
  closeAutoRenewal: 'Close Auto Renewal',
  closeAutoRenewalConfirm: 'Close Auto Renewal',
  closeAutoRenewalTip: 'Close auto renewal? Service will not auto-renew after expiry.',
  closeFailed: 'Close failed',
  closeSuccess: 'Closed successfully',
  collectCount: 'Collection Count',
  commonArea: 'Common Area',
  commonAreaLabel: 'Common Area:',
  complete: 'Completed',
  confirmFreezeAccount: 'Confirm to {action} account {account}?',
  confirmUnsubscribe: 'Confirm to unsubscribe?',
  confirmWithdrawApply: 'Confirm to withdraw this application?',
  contact: 'Contact',
  contactInfo: 'Contact',
  correctRate: 'Correct Rate',
  correctRateOrScoreRate: 'Correct rate (or score rate)',
  courseName: 'Course Name',
  courseType: 'Course Type',
  courseTypeFormal: 'Formal course',
  courseTypeFormalRetake: 'Formal course retake',
  courseTypeFoundation: 'Foundation',
  courseTypeFoundationDowngrade: 'Foundation downgrade',
  courseTypeFoundationRetake: 'Foundation retake',
  courseTypeFoundationUpgrade: 'Foundation upgrade',
  courseTypeRetake: 'Retake',
  courseTypeSyncStudy: 'Synchronous study',
  createTime: 'Create Time',
  crossEntityApplySuccess: 'Cross-entity supervision application submitted',
  currentCertArea: 'Current Cert Area',
  currentCertAreaLabel: 'Current Cert Area:',
  currentCommonAreaLabel: 'Current Common Area:',
  currentServiceCenter: 'Current Service Center:',
  currentServiceCenterId: 'Current Service Center ID:',
  currentServiceCenterName: 'Current Service Center Name:',
  currentStudyEndDate: 'Current Study End Date',
  crossEntitySupervisionQuotaPeriod: 'Statistics Period:',
  crossEntitySupervisionQuotaDealer: 'Dealer:',
  crossEntitySupervisionQuotaDealerPlaceholder: 'Please enter Dealer ID',
  crossEntitySupervisionQuotaDealerId: 'Dealer ID',
  crossEntitySupervisionQuotaDealerName: 'Dealer Name',
  crossEntitySupervisionQuotaArea: 'Area',
  crossEntitySupervisionQuotaStudentCount: 'Same-entity supervised student count',
  crossEntitySupervisionQuotaExemptLimit: 'Same-entity exempt quota',
  crossEntitySupervisionQuotaUsedLimit: 'Same-entity used quota',
  crossEntitySupervisionQuotaCurrentUsedLimit: 'Current dealer used quota',
  crossEntitySupervisionQuotaUpperLimit: 'Same-entity upper quota',
  customDiscountExceedTotal: 'Custom discount cannot exceed total price',
  customer: 'Search Customer',
  customerName: 'Customer Name / Phone',
  dailyKnowledgePointSelfStudyCount: 'Daily knowledge point self-study count',
  danhao: 'Repair Order No.',
  dataDescription: 'Data description',
  dataDescriptionByMonth: 'Data description: Data updates on the 1st of each month. For data definitions, please go to Help Center',
  dataDescriptionDayDelay: 'Data description: Data has 1-day delay, updated daily at midnight. For data definitions, please go to Help Center',
  dataDescriptionTip: 'Data may have up to 1 hour update delay. For data definitions, please go to Help Center',
  date: 'Date',
  dateLabel: 'Date:',
  pleaseSelectDateRange: 'Please select date range',
  day: 'Subscription Log Details',
  dayhour: 'Log Statistics Start Time',
  ddjDurationInPeriod: 'DDJ duration in period',
  ddjEffectAbnormal: 'DDJ self-study effect abnormal:',
  ddjEfficiencyAbnormal: 'DDJ self-study efficiency abnormal:',
  dealer: 'Dealer ID',
  dealerId: 'Dealer ID',
  dealerIdLabel: 'Dealer ID:',
  dealerName: 'Dealer Name',
  dealerNameLabel: 'Dealer Name:',
  deductDurationLabel: 'Deduct Duration:',
  deleteSuccess: 'Deleted successfully!',
  deliveryAddressLabel: 'Delivery Address:',
  details: 'Details',
  device: 'Device SN Code',
  deviceSNCode: 'Device SN Code',
  deviceSNCodeLabel: 'Device SN Code:',
  dialTime: 'Dial Time',
  dianhua: 'Recipient Phone',
  dili: 'Geography',
  dingshiqu: 'Subscription Duration Area',
  discountAmount: 'Discount Amount',
  dishu: 'Foundation Building Count',
  distributionTime: 'Distribution Time',
  reviewTime: 'Review Time',
  download: 'Download',
  downloadElectronicCert: 'Download E-Certificate',
  downloadEnrollmentPoster: 'Download Enrollment Poster',
  downloadFailed: 'Download failed',
  downloadSuccess: 'Download successful',
  durationDetailHours: 'Duration Detail (hours)',
  editFailed: 'Edit failed',
  editSuccess: 'Edited successfully',
  effectiveDurationHours: 'Effective Duration (hours)',
  englishName: 'English Name',
  guinnessEnglishNameLabel: 'English Name',
  enrollParent: 'Enroll Parent',
  enrollTime: 'Enroll Time',
  enrollmentName: 'Enrollment Name',
  enrollmentPosterFilename: '{userName}_enrollment_poster-{createTime}.png',
  er: 'Payment QR Code Valid Period:',
  errorCategory: 'Error Category',
  errorCount: 'Error Count',
  errorRate: 'Error Rate',
  eryear: 'Grade 2',
  exchangeLearningMachine: 'Exchange Learning Machine',
  exchangeMachineSN: 'Exchange Machine SN',
    exchangeSuccess: 'Exchange successful!',
  expectedGiftHours: 'Expected gift hours',
  expirationTime: 'Expiration Time',
  export: 'Export',
    exportFailRetry: 'Export failed, please try again later',
  exportReport: 'Export Report',
  fastTrackBindNoAuditDesc: 'After using this channel, account binding will be exempt from audit.',
  fastTrackNoAudit: 'Fast Track No Audit',
    feedbackThanks: 'Your feedback motivates us!',
  fen: 'Liveness Score',
  fenlei: 'Actual Fault Classification',
  fieldDescription: 'Field Description',
  fileUploadingWait: 'File uploading, please wait before submit',
  fill: 'Fill',
  fillAddressStep: 'Fill in Delivery Address',
  fillEnglishName: 'Fill in Student English Name',
  finalAbilityValue: 'Final Ability Value',
  finalAvgAbility: 'Final average ability',
  fiveStarCount: '5-Star',
  foundationCourseStudyDuration: 'Foundation Course Study',
  foundationDuration: 'Foundation',
  foundationEffectiveDuration: 'Foundation Effective',
  foundationErrorCorrectionDuration: 'Foundation Error Correction',
  foundationStudyDuration: 'Foundation study duration',
  fourStarCount: '4-Star',
  freeze: 'Freeze',
  freezeSubscriptionTip: 'After freezing, subscription duration in this account cannot be used.',
  freezeSuccess: 'Account frozen successfully',
  frozen: 'Frozen',
  generatingText: 'Generating...',
  gengqu: 'Change Area',
  giftFailed: 'Gift failed',
  giftReason: 'Gift Reason',
  giftSubscriptionBalance: 'Gift Subscription Balance',
  giftSubscriptionCardUsage: 'Gift Subscription Card Usage',
  giftSubscriptionDuration: 'Gift Subscription Duration',
  giftSubscriptionDurationLabel: 'Gift Subscription Duration',
  giftSubscriptionMonths: 'Gift Subscription Months',
  giftSubscriptionType: 'Gift Subscription Type',
  giftSuccess: 'Gift successful',
  giftedHours: 'Gifted hours',
  goNow: 'Go Now',
  gotIt: 'Got it',
  grade: 'Grade',
  hao: 'One Person One Number Return',
  healthDegree: 'Health Degree',
  healthPersonCount: 'Healthy Person-Courses',
  healthRate: 'Health Rate',
  highActiveDuration: 'High Active',
  highActiveEffectiveDuration: 'High Active Effective',
  highActiveEffectiveRatio: 'High Active Effective Ratio',
  highActiveRate: 'High Active Rate',
  hour: 'Subscription Duration Details',
  hourhour: 'Muttering Usage Duration Report',
  hoursTipAreaMatch: 'Common area matches cert area. Recommend area duration recharge.',
  hoursTipAreaMismatch: 'Common area mismatches cert area. Recommend universal duration recharge.',
  hoursTipUniversal: 'Universal duration available. Please select recharge type as needed.',
  houryici: 'Use previous params',
  hua: 'Video Call Service',
  iKnow: 'Got it',
  id: 'ID',
    imageAddFailed: 'Failed to add image',
  imageFormatJpgPngGifBmp: 'Only JPG, JPEG, GIF, PNG, BMP format images allowed~',
  imageLoadFailCheckNetwork: 'Image load failed, please check network',
    imageMax9Count: 'Maximum 9 images allowed~',
    imageNoDuplicate: 'Duplicate images not allowed~',
  imageSizeExceed5M: 'Image size exceeds 5M limit~',
  imageSizeExceed8M: 'Image size cannot exceed 8MB!',
  info: 'Face 2 Most Similar Face Info',
  information: 'Information',
  inviteStudentTransfer: 'Invite Student Transfer',
  jianli: 'Suggested Handling Method',
  jie: 'Recognition Result',
  jiuyear: 'Grade 9',
  kaiding: 'Open Subscription',
  kanshi: 'Video Watch Duration (Inexact)',
  kexue: 'Science',
  knowIt: 'Got it',
  knowledgePointCode: 'Knowledge Point Code',
  knowledgePointName: 'Knowledge Point Name',
  knowledgePointNote: 'Knowledge Point Note',
  lastExamDate: 'Last Exam Date',
  learningArea: 'Learning Area',
  learningAreaLabel: 'Learning Area:',
  li: 'Physics',
  lijie: 'Repair Handling Result',
  linkedStudents: 'Linked Students',
  liuyear: 'Grade 6',
  loadFailed: 'Load failed',
  loadingText: 'Loading...',
  ma: 'SN Code:',
  machine: 'Learning Machine Account',
  machineAccount: 'Machine Account:',
  machineAccountCode: 'Machine Account No.:',
  machineAccountLabel: 'Machine Account:',
  machineAccountPhoneLabel: 'Machine Account Phone:',
  machineRenewal: 'Machine Renewal',
  machineSNCode: 'Machine SN Code',
  machineSNCodeLabel: 'Machine SN Code:',
  machineSubscribeStatus: 'Machine Subscribe Status',
  maintenancePurchaseNoLabel: 'Purchase No.:',
  maintenancePleaseEnterPurchaseNo: 'Please enter purchase no.',
  maintenanceProductType: 'Product Type',
  maintenancePleaseSelectProductType: 'Please select product type',
  maintenanceApplyNoLabel: 'Repair Order No.:',
  maintenancePleaseEnterApplyNo: 'Please enter repair order no.',
  maintenanceEstimateFaultType: 'Estimated Fault Type',
  maintenancePleaseSelectEstimateFaultType: 'Please select estimated fault type',
  maintenanceActualFaultType: 'Actual Fault Type',
  maintenancePleaseSelectActualFaultType: 'Please select actual fault type',
  maintenanceFirmUser: 'Repair Vendor',
  maintenancePleaseSelectFirmUser: 'Please select repair vendor',
  maintenanceReceiverPhone: 'Receiver Phone',
  maintenancePleaseEnterNewSNCode: 'Please enter new SN code',
  maintenanceFirstDiagnosisMethod: 'First Diagnosis Method',
  maintenanceActualMethod: 'Actual Handling Method',
  maintenanceSearchProposeMethodLabel: 'Suggested Handling',
  maintenanceSearchFirstDiagnosisMethodLabel: 'First Diagnosis',
  maintenanceSearchActualMethodLabel: 'Actual Handling',
  maintenanceQuotationPayType: 'Quoted Payment Status',
  maintenancePleaseSelectQuotationPayType: 'Please select quoted payment status',
  maintenanceQuotedUnpaid: 'Quoted, Unpaid',
  maintenanceQuotedPaid: 'Quoted, Paid',
  maintenanceApplyNo: 'Repair Order No.',
  maintenanceDeviceSnOrPurchaseNo: 'Device SN / Purchase No.',
  maintenanceRenewEffectiveTime: 'Renew Effective Time',
  maintenanceWarrantyValidTime: 'Warranty Valid Time',
  maintenanceCreateTime: 'Created Time',
  maintenanceCreator: 'Created By',
  maintenanceAuditTime: 'Audit Time',
  maintenanceAuditor: 'Audited By',
  maintenanceAuditRemark: 'Audit Remark',
  maintenanceProcessTime: 'Repair Time',
  maintenanceProcessResult: 'Repair Result',
  maintenanceSuggestMethod: 'Suggested Handling Method',
  maxBindLimit: 'Max Bind Limit',
  boundAccountCount: 'Bound Account Count',
  min: 'Actually No Pagination Needed',
  minhour: 'When paginating',
  minmin: 'Daily Student Score Improvement Analysis',
  minyear: 'Grade Table Column Distinction',
  missingAccountInfo: 'Missing required account info. Cannot proceed.',
  mobile: 'Phone',
  mobileRequired: 'Phone number is required',
  modifyArea: 'Modify Area',
  modifyAreaFailed: 'Failed to modify area',
  modifyAreaSuccess: 'Area modified successfully',
    modifySuccess: 'Modified successfully',
  month: 'Subscription Duration (Months)',
  monthAvgPrice: 'Monthly Avg Price',
  monthUnit: ' month',
  monthlyRemainQuota: 'Monthly remaining quota',
  monthsUnit: ' months',
  more: 'More',
  name: 'Name',
  nationwide: 'Nationwide',
  newMachineAccount: 'New Machine Account',
  newMachineAccountArea: 'New Machine Account Area',
  newPhone: 'New Phone',
  newPhoneLabel: 'New Phone:',
  newStudentFacePhoto: 'New Student Face Photo',
  newStudentFacePhotoLabel: 'New Student Face Photo:',
  newStudentName: 'New Student Name',
  newStudentNameLabel: 'New Student Name:',
  nextStep: 'Next Step',
  nnycDuration: 'Nnyc Duration',
  noData: 'No Data',
  none: 'None',
  normal: 'Normal',
  not: 'Not Activated',
  notSubscribed: 'Not Subscribed',
  notUse: 'Not Use',
  num: 'Face Count',
  objectiveQuestionCount: 'Objective questions',
  oneStarCount: '1-Star',
  onlyLastHalfYearTip: '* Only data from the last 6 months is shown. For more learning data, please check the analyst system.',
  onlyLastYearTip: '* Only data from the last year is shown. For more learning data, please check the analyst system.',
    onlyUploadImage: 'Only image files allowed!',
  openAutoRenewal: 'Open Auto Renewal',
  openAutoRenewalConfirm: 'Open Auto Renewal Service',
  openAutoRenewalTip: 'Enable auto renewal? Service will auto-renew after expiry.',
  openFailed: 'Activation failed',
  openService: 'Open Service',
  openSuccess: 'Activated successfully',
  openVideoCallService: 'Open Video Call Service',
  cancelShutdown: 'Cancel Shutdown',
  operateChannel: 'Operate Channel',
  operateDate: 'Operate Date',
  operateTime: 'Operate Time',
  operateType: 'Operate Type',
  operation: 'Operation',
    operationFail: 'Operation failed',
    operationSuccess: 'Operation successful',
  operator: 'Operator',
  originStudyTimeSec: 'Origin study time (sec)',
  originalPhone: 'Original Phone',
  originalPhoneLabel: 'Original Phone:',
  otherSubject: 'Other',
  overallCorrectRate: 'Overall correct rate',
  pass: 'Temporary Pass',
  passportRecordExport: 'Passport Record Export',
  passportRecordAdaptiveAccountText: 'Adaptive Account',
  passportStudyData: 'Student Passport Study Data',
  pay: 'Pay',
    payDeductTip: 'This payment will deduct:',
    payFailTip: 'Payment failed ¥{money}',
  paySuccessTip: 'Successfully paid ¥{money}',
  paymentFailed: 'Payment failed',
  paymentSuccess: 'Payment successful',
  // Student video service related
  studentNameLabel: 'Student Name:',
  adaptiveAccountLabel: 'Adaptive Account:',
  servicePriceLabel: 'Service Price:',
  accountBalanceLabel: 'Account Balance:',
  videoServiceDurationColon: 'Service Duration:',
  videoCallDurationColon: 'Call Duration:',
  videoCashAccountLabel: 'Cash Account',
  remainingPayment457: 'Remaining Payment',
  videoPaymentMethodLabel: 'Payment Method',
  returnExpressNoLabel: 'Return shipment',
  factoryExpressNoLabel: 'Shipment to factory',
  faceRiskBaselinePhotoLabel: 'Face reference photo',
  faceRiskCollectionMethodLabel: 'Collection method',
  faceRiskLivenessMethodLabel: 'Liveness detection method',
  faceRiskRecognitionSimilarityLabel: 'Recognition similarity',
  faceRiskCompareImageLabel: 'Image',
  paymentSuccessExclaim: 'Payment successful!',
  pending: 'Pending Review',
  pendingApprovalRetry: 'Accounts pending approval. Please wait for approval and retry.',
  phoneColon: 'Phone:',
  phoneLabel: 'Phone:',
  phoneRebind: 'Phone Rebind',
  phoneRebindTitle: 'Phone Rebind',
  phoneVerifyCode: 'Phone Verify Code:',
  pleaseAddProductQty: 'Please add product quantity',
  pleaseEnter: 'Please enter SN code',
  pleaseEnterAccountStatus: 'Enter account status',
  pleaseEnterAdaptiveAccount: 'Enter adaptive account',
  pleaseEnterAddress: 'Enter delivery address',
    pleaseEnterAgentWarehouse: 'Enter agent warehouse',
  pleaseEnterAnalystNamePhone: 'Enter analyst name or phone',
  pleaseEnterAuditRemark: 'Enter audit remark',
  pleaseEnterChangeType: 'Enter change type',
  pleaseEnterCityDistrict: 'Please enter city/district',
  pleaseEnterDetailAddress: 'Please enter detailed address, e.g. Province City District Street No.',
  pleaseEnterDetailDesc: 'Enter detail description',
    pleaseEnterDeviceSN: 'Enter device SN',
  pleaseEnterDeviceSNOrOrderNo: 'Enter device SN or order no.',
  pleaseEnterEnglishName: 'Enter student English name',
  pleaseEnterFirstDiagnosisResult: 'Enter first diagnosis result',
  pleaseEnterInspectionDesc: 'Enter inspection description',
  pleaseEnterMachineAccount: 'Enter machine account',
  pleaseEnterNameAccount: 'Enter name or account',
  pleaseEnterNameOrAccount: 'Enter name or account',
    pleaseEnterNewMachineSN: 'Enter new machine SN',
  pleaseEnterNewPhone: 'Please enter new phone number',
  pleaseEnterPhone: 'Enter phone number',
  pleaseEnterProvinceCity: 'Select province/city',
  pleaseEnterPurchaseType: 'Enter purchase type',
  pleaseEnterQualityRemark: 'Enter quality check remark',
  pleaseEnterQuotationDesc: 'Enter quotation description',
  pleaseEnterReceiver: 'Enter receiver name',
  pleaseEnterReceiverAddress: 'Enter receiver address',
  pleaseEnterReceiverPhone: 'Enter receiver phone',
  pleaseEnterRechargeActivityDuration: 'Enter recharge activity duration',
  pleaseEnterRemark: 'Enter remark',
  pleaseEnterRepairResult: 'Enter repair result',
  pleaseEnterReturnReceiver: 'Enter return receiver name',
  pleaseEnterMachineAccountPhone: 'Enter machine account phone',
  pleaseEnterSNCode: 'Enter SN code',
  pleaseEnterServiceCenterIdName: 'Enter service center ID or name',
  pleaseEnterStudentAccount: 'Enter student account',
  pleaseEnterStudentAccountOrName: 'Enter student account or name',
  pleaseEnterStudentName: 'Enter student name',
  pleaseEnterStudentNameOrAccount: 'Enter student name or account',
  pleaseEnterVideoCallStudentNameAccount: 'Enter student name or account',
  pleaseEnterStudentNamePhone: 'Enter student name or phone',
  pleaseEnterStudentNamePhoneAccount: 'Enter student name, phone or account',
    pleaseEnterTrackingNo: 'Enter tracking number',
  pleaseEnterUser: 'Enter user',
  pleaseEnterUserPlaceholder: 'Enter user',
  pleaseEnterUserAccountOrName: 'Enter user account or user name',
  pleaseEnterValidPhone: 'Enter a valid phone number',
  pleaseEnterVerifyCode: 'Enter verification code',
  pleaseFillApplicationReason: 'Enter application reason',
  pleaseFillCardNo: 'Enter subscription card number',
  pleaseFillCardPassword: 'Enter subscription card password',
  pleaseFillGiftDuration: 'Enter gift subscription duration',
  pleaseFillGiftReason: 'Enter gift reason, 2-200 characters',
  pleaseFillMachineSN: 'Enter machine SN code',
  pleaseFillMonth: 'Enter month',
  pleaseFillNewPhone: 'Enter new phone number',
  pleaseFillNewStudentName: 'Enter new student name',
  pleaseFillOriginalPhone: 'Enter original phone number',
    pleaseFillRemark: 'Enter remark',
  pleaseFillStudentAccount: 'Enter student account',
  pleaseSearchCourseName: 'Search course name',
  pleaseSearchStudyCount: 'Search self-study count',
  pleaseSelect: 'Please select operation type',
  pleaseSelectPassportType: 'Please select passport type',
  pleaseSelectStatus: 'Please select status',
  pleaseSelectReviewStatus: 'Please select review status',
  pleaseSelectAccountStatus: 'Select account status',
  pleaseSelectActualFaultType: 'Select actual fault type',
  pleaseSelectActualMethod: 'Select actual handling method',
    pleaseSelectAfterSalesMethod: 'Select after-sales method',
  pleaseSelectAgent: 'Select agent',
  pleaseSelectChangeType: 'Select change type',
  pleaseSelectAssignPerson: 'Select assignee',
    pleaseSelectAtLeastOneOption: 'Select at least one option',
  pleaseSelectAuditResult: 'Select audit result',
  pleaseSelectCallStaff: 'Select call staff',
  pleaseSelectCourseType: 'Select course type',
  pleaseSelectDispatchType: 'Select dispatch type',
  pleaseSelectExpressCompany: 'Select express company',
    pleaseSelectFillResult: 'Select fill result',
  pleaseSelectFirstDiagnosisMethod: 'Select first diagnosis method',
  pleaseSelectFirstDiagnosisResult: 'Select first diagnosis result',
  pleaseSelectFullTimeDateRange: 'Select full-time start/end date',
  pleaseSelectFullTimeType: 'Select full-time type',
  pleaseSelectGiftType: 'Select gift subscription duration type',
  pleaseSelectGrade: 'Select grade',
  pleaseSelectInspectionResult: 'Select inspection result',
  pleaseSelectMonth: 'Select month',
  pleaseSelectNonWarrantyReason: 'Select non-warranty reason',
    pleaseSelectPaymentResult: 'Select payment result',
  pleaseSelectProductFirst: 'Please select product first',
  pleaseSelectProvinceCity: 'Select province/city',
  pleaseSelectPurchaseType: 'Please select purchase type first',
  pleaseSelectQualityResult: 'Select quality check result',
  pleaseSelectRenewDurationType: 'Please select renew duration type',
  pleaseSelectRenewMonth: 'Select renew month',
  pleaseSelectRepairResult: 'Select repair result',
    pleaseSelectRepairVendor: 'Select repair vendor',
  pleaseSelectResult: 'Select result',
  pleaseSelectReturnResult: 'Select return result',
  pleaseSelectShipAreaAgent: 'Select shipment area agent',
  pleaseSelectSubject: 'Select subject',
    pleaseSelectSuggestMethod: 'Select suggested handling method',
  pleaseSelectSupervisorMark: 'Select supervisor mark',
    pleaseUploadFullTimeAgreement: 'Upload signed full-time agreement',
  pleaseUploadImage: 'Please upload image',
  pleaseUploadImageOrVideo: 'Please upload image/video',
  pleaseUploadReturnMedia: 'Please upload return image/video',
  postStudyAvgAbility: 'Post-study avg ability',
  posterGeneratedDownload: 'Poster generated, downloading',
  preTestCorrectRate: 'Pre-test correct rate',
  precisionTestDuration: 'Precision Test',
  prevStep: 'Previous',
  priceLabel: 'Price:',
  productName: 'Product Name',
  proofMaterial: 'Proof Material',
  proofMaterialLabel: 'Proof Material:',
  proofUploadTip: 'Please upload proof that the child using the machine is from the same family. Supports jpg/png, max 20MB',
  provinceCityLabel: 'Province/City:',
  purchase: 'Purchase Order No.:',
  qi: 'Expiration Reason',
  qingtijiao: 'Applicant',
  qita: 'Other',
  qiyear: 'Grade 7',
  qu: 'Area',
  queryFailRetry: 'Query failed, please try again later',
  queryRenewMonthFailed: 'Failed to query renew months',
  questionCount: 'Question count',
  rebindFailed: 'Rebind failed',
  rebindSuccess: 'Rebind successful',
  receiverLabel: 'Receiver:',
  receiverPhoneLabel: 'Receiver Phone:',
  recentModuleName: 'Recent Self-study Module',
  rechargeActivityDuration: 'Recharge Activity Duration',
  rechargeActivityDurationReminder: 'Recharge Activity Duration Reminder',
  rechargeAreaDuration: 'Recharge Area Duration',
  rechargeAreaDurationTitle: 'Recharge Area Duration',
  rechargeAtServiceCenter: 'If the student is under your service center, please recharge in the account management page.',
  rechargeDurationTip: 'Recharge duration can only be operated by student service center.',
  rechargeSuccess: 'Recharge successful',
  rechargeUniversalDuration: 'Recharge Universal Duration',
  recognitionCount: 'Recognition Count',
  refreshFailed: 'Refresh failed',
  region: 'Region',
  rejectReason: 'Reject Reason:',
  rejectReasonPlaceholder: 'If rejected, enter reason (feedback to student). Max 50 chars',
  remainingRechargeableDuration: 'Remaining rechargeable duration',
  remark: 'Remark',
  renew: 'Auto Renew',
  renewAreaTypeConfirm: 'You selected region type. After renewal, it cannot be used directly due to common area mismatch. Confirm to renew?',
  renewDurationTypeLabel: 'Renew Duration Type:',
  renewMonthLabel: 'Renew Month:',
  renewPriceRuleNotExist: 'Renew price rule not configured',
  renewalReminder: 'Machine Renewal Reminder',
  renqu: 'Current Authentication Area',
  reportDate: 'Report Date',
  reportType: 'Report Type',
  reportWeekStartDate: 'Report Week Start',
  resend: 'Resend',
  resendAfterSeconds: 'Resend in {n}s',
  resendAfterSecondsTip: 'Resend in {n}s',
  responsibleStudentCount: 'Students Responsible',
  retakeCount: 'Retake count',
  returnFactoryFailed: 'Return to factory operation failed',
  returnFactorySuccess: 'Return to factory operation successful',
  san: 'Grade 12',
  sanyear: 'Grade 3',
  saveFailed: 'Save failed',
  saveSuccess: 'Save successful',
  // Quotation related translations
  repairQuotationActualMethodLabel: 'Actual Processing Method',
  repairQuotationPleaseSelectActualMethod: 'Please select actual processing method',
  repairQuotationActualFaultTypeLabel: 'Actual Fault Type',
  repairQuotationPleaseSelectFaultClass: 'Please select fault classification',
  repairQuotationNonWarrantyReasonLabel: 'Non-warranty Reason',
  repairQuotationPleaseAddDetail: 'Please add repair details',
  repairQuotationSerialNoLabel: 'No.',
  repairQuotationCategoryLabel: 'Repair Category',
  repairQuotationDetailLabel: 'Repair Details',
  repairQuotationAmountLabel: 'Repair Amount',
  repairQuotationDescriptionLabel: 'Description',
  repairQuotationOperationLabel: 'Operation',
  repairQuotationDeleteLabel: 'Delete',
  repairQuotationCustomDiscountLabel: 'Custom Discount Amount',
  repairQuotationDescTitleLabel: 'Quotation Description',
  repairQuotationDescPlaceholder: 'Please enter quotation description, within 400 characters',
  repairQuotationFillResultLabel: 'Fill Result',
  repairQuotationFaultImagesLabel: 'Fault Images',
  repairQuotationTotalAmountLabel: 'Total Repair Amount',
  repairQuotationAddDetailLabel: 'Add Repair Details',
  repairQuotationUploadImageLabel: 'Upload Image',
  // First trial related translations
  repairFirstVisitSuggestedMethodLabel: 'Suggested Treatment Method',
  repairFirstVisitPleaseSelectSuggestedMethod: 'Please select suggested treatment method',
  repairFirstVisitMethodLabel: 'First Diagnosis Treatment Method',
  repairFirstVisitPleaseSelectMethod: 'Please select first diagnosis treatment method',
  repairFirstVisitDescLabel: 'First Diagnosis Description',
  repairFirstVisitDescPlaceholder: 'Please enter first diagnosis description, within 400 characters',
  repairFirstVisitResultLabel: 'First Diagnosis Result',
  repairFirstVisitExpectedTimeLabel: 'Expected Completion Time',
  repairFirstVisitMediaLabel: 'First Diagnosis Images/Videos',
  repairFirstVisitFactoryExpressInfoLabel: 'Return Factory Express Info',
  repairFirstVisitUploadMediaLabel: 'Upload Images/Videos',
  repairFirstVisitSaveLabel: 'Save',
  repairFirstVisitReadFaultDescLabel: 'Read Fault Description',
  repairFirstVisitAgreeLabel: 'Agree',
  repairFirstVisitRejectLabel: 'Reject',
  repairFirstVisitLocalUploadLabel: 'Local File Upload',
  repairFirstVisitCaptureMediaLabel: 'Capture Image/Video',
  pleaseSelectExpectedTime: 'Please select expected completion time',
  school: 'School:',
  clearanceCycleDays: 'Clearance Cycle (Days)',
  clearanceTime: 'Clearance Time',
  to: 'to',
  reTime: 'Restart Time',
  postLearningAccuracy: 'Post-learning Accuracy',
  preLearningAccuracy: 'Pre-learning Accuracy',
  search: 'Search Student:',
  searchAnalyst: 'Search Analyst',
  searchAnalystLabel: 'Search Analyst:',
  searchStudent: 'Search Student',
  searchStudentLabel: 'Search Student:',
  scmAccountMgmtStudentSearchPlaceholder: 'Enter student account or student name',
  scmAccountMgmtAccountStatusFilterLabel: 'Account status:',
  scmAccountMgmtAccountStatusFilterPlaceholder: 'Enter account status',
  scmAccountMgmtMachineAccountPlaceholder: 'Enter machine account',
  scmAccountMgmtSubAuthFilterPlaceholder: 'Select account status',
  scmSubAuthNot: 'Unauthorized',
  scmSubAuthIng: 'Authorizing',
  scmSubAuthAlready: 'Authorized',
  scmAccountMgmtActivateDateLabel: 'Account activation date',
  scmAccountMgmtSnPlaceholder: 'Enter SN code',
  scmAccountMgmtCertAreaPlaceholder: 'Select province/city',
  pleaseSelectStatus: 'Select status',
  guinnessStudentNameText: 'Student Name',
  guinnessElectronicStatusLabel: 'E-Certificate Status:',
  guinnessPaperStatusLabel: 'Paper Certificate Status:',
  guinnessElectronicStatusHeader: 'E-Certificate Status',
  guinnessPaperStatusHeader: 'Paper Certificate Status',
  guinnessStatusNotApplied: 'Not Applied',
  guinnessStatusApplied: 'Applied',
  guinnessStatusPaying: 'Payment in Progress',
  guinnessStatusAppliedMaking: 'Applied, In Progress',
  guinnessStatusCompleted: 'Completed',
  searchUser: 'Search user',
  sec: 'Auto close after seconds',
  sectionName: 'Section Name',
  selectDate: 'Select date',
  selectStudentStep: 'Select Students to Apply',
  selectStudentTip: 'Select Student Notice',
  selectedCount: 'Selected {n}',
  selfStudyDate: 'Self-study Date',
  sendVerifyCode: 'Send Code',
  serialNumber: 'No.',
  serviceCenterId: 'Service Center ID',
  serviceCenterIdLower: 'Service Center id',
  serviceCenterSimple: 'Service Center',
  serviceCenterIdLabel: 'Service Center ID:',
  serviceCenterLabel: 'Service Center',
  serviceCenterName: 'Service Center Name',
  serviceCenterNameLabel: 'Service Center Name:',
  servicePersonLabel: 'Service Person:',
  pleaseSelectServicePerson: 'Please select service person',
  shang: 'Repair Vendor',
  sheng: 'Biology',
  showSampleAccount: 'Show sample account',
  shu: 'Video Count',
  shuoming: 'Detailed Description',
  shuxue: 'Math',
  siyear: 'Grade 4',
  snCode: 'SN Code',
  snCodeLabel: 'SN Code:',
  songuoSubscriptionCard: 'Songuo Subscription Card',
  stage: 'Stage',
  stageGrade: 'Stage/Grade:',
  startTime: 'Start Time',
  statisticsDate: 'Statistics Date',
  statsDateRange: 'Statistics Date Range',
  statsPeriod: 'Statistics Period',
  accountStatus: 'Account Status',
  authorizationStatus: 'Authorization Status',
  status: 'Status',
  reviewStatus: 'Review Status',
  passportReviewNoNeed: 'No Review Needed',
  passportReviewPending: 'Pending Review',
  passportReviewComplete: 'Review Completed',
  student: 'Student Account Subject',
  studentAccount: 'Account',
  studentAccountColon: 'Student Account:',
  studentAccountLabel: 'Student Account',
  guinnessStudentAccountHeader: 'Student Account',
  studentEnglishName: 'Student English Name',
  studentImproveAnalysisDataDescriptionTip: 'Data updates daily at 9:00 AM. For definitions, please visit the Help Center.',
  studentImproveAnalysisExport: 'Student Improve Analysis',
  studentImproveAnalysisImportantRemind: "Important reminder: To ensure fair comparison across grades, before calculating the last 180-day average score improvement, average exam score, and score standard deviation, we standardize each student's exam scores to a 100-point scale.",
  studentLabel: 'Student',
  studentName: 'User Name',
  studentNameColon: 'Student Name:',
  studentNameLabel: 'Student Name',
  studentNameLabelColon: 'Student Name:',
  studentNameStudyTimeReport: 'Student name',
  studentNameOrAccount: 'Student name/account',
  studentNamePhone: 'Student Name/Phone',
  studentServiceDurationTip: 'Student service duration is {studentDays} days, does not meet {requiredDays} days requirement. Cannot renew for this student.',
  studentTransferApply: 'Student Transfer Apply',
  studyCorrectRate: 'Study correct rate',
  studyCount: 'Self-study count',
  studyDate: 'Study Date',
  studyDays: 'Study days',
  studyDurationHours: 'Study Duration (h)',
  subject: 'Subject',
  subjectLabel: 'Subject:',
  subjectName: 'Subject',
  subjectiveScoreRate: 'Subjective score rate',
  submitFailed: 'Submit failed',
  submitInformation: 'Submit Information',
  submitMaterial: 'Submit Material',
  submitSuccess: 'Submit successful',
  subscribe: 'Subscribe',
  subscribeConfirm: 'Subscribe Confirm',
  subscribeDurationArea: 'Subscribe Duration Area',
  subscribeDurationMonths: 'Subscribe Duration Months',
  subscribeSubjectManage: 'Subscribe Subject Management',
  subscribed: 'Subscribed',
  subscribedSubjects: 'Subscribed Subjects',
  subscriptionCancelDate: 'Recent Subscribe/Cancel Date',
  subscriptionCardLabel: 'Subscription Card',
  subscriptionCardNo: 'Subscription Card No.',
  subscriptionCardNoLabel: 'Subscription Card No.:',
  subscriptionCardPassword: 'Subscription Card Password',
  subscriptionCardPasswordLabel: 'Subscription Card Password',
  subscriptionCardPasswordLabelColon: 'Subscription Card Password:',
  subscriptionCardType: 'Subscription Card Type',
  subscriptionCardTypeLabel: 'Subscription Card Type:',
  subscriptionCardVerifySuccess: 'Subscription card verified successfully',
  subscriptionDurationLessThan3: 'Available subscription ≤3 days',
  subscriptionManagement: 'Subscription Management',
  subscriptionSubjectLabel: 'Subscription Subject:',
  supervisorMark: 'Supervisor Mark',
  supervisorShop: 'Store',
  pleaseSelectSupervisorShop: 'Please select store',
  supervisorUnmarked: 'Unmarked',
  supervisorStudyRoom: 'Study Room',
  supervisorOnlineOnly: 'Online Only',
  supervisorExpired: 'Supervision Expired',
  supervisorNoSupervise: 'No Supervision',
  supervisorStatus: 'Supervisor Status',
  syncCourse: 'Sync Course Accuracy Rate',
  syncCourseCorrectQuestionCount: 'Sync course correct answers',
  syncCourseCorrectRate: 'Sync course correct rate',
  syncCourseDuration: 'Sync Course',
  syncCourseEffectiveDuration: 'Sync Course Effective',
  syncCourseStudyDuration: 'Sync Course Study',
  syncCourseTotalQuestionCount: 'Sync course questions',
  syncErrorCorrectionDuration: 'Sync Error Correction',
  taskCardCompleteTime: 'Task Card Completion Time',
  taskCardName: 'Task Card Name',
  text0128: 'Please fill in your express delivery information on the page',
  text02ok: 'Fault description button disabled',
  text041r: 'Avoid damage during transit',
  text0dkm: 'If accessories are missing',
  text0kxb: 'Unit',
  text0nkv: 'Not as final product judgment result',
  text0pnd: 'Then',
  text0tih: 'Your submitted',
  text0twu: 'Payment information',
  text0uhw: 'Use WeChat Pay',
  text0y39: 'Dear partner:',
  text0z0g: 'Actual fault type',
  text16i0: 'I have read and understood',
  text1a2b: 'Table merge field',
  text1b76: 'Quality inspection',
  text1cd3: 'Tracking number',
  text1e1u: 'Payment completed',
  text1fdw: 'Supervisor',
  text1gih: 'Initial diagnosis reminder',
  text1nox: 'Score stability (days)',
  text1nv3: 'Quality inspection',
  text214l: 'Total repair amount',
  text2192: 'Image preview',
  text23it: 'Whole machine replacement',
  text23os: 'Then',
  text26cj: 'Exceeded',
  text29kt: 'Page size',
  text2af3: 'Vertical',
  text2cem: 'Pass code',
  text2eo7: 'Old data',
  text2iu8: 'In-warranty repair',
  text2lb9: 'Current page',
  text2obh: 'Default selection',
  text2py7: 'Initial diagnosis description',
  text2us2: 'Courier company',
  text2vll: 'Out-of-warranty repair requires fee',
  text2vpv: 'Vendor address',
  text303b: 'Please select subject',
  text358v: 'Set default parameters',
  text3alh: 'Region',
  text3bv7: 'Get',
  text3d7q: 'All status table columns',
  text3ehe: 'Suggested handling method',
  text3gqv: 'Return images',
  text3zas: 'Repair detail data',
  text3zgs: 'Size',
  text458z: 'English',
  text46ll: 'Video',
  text498v: 'Your device repair application',
  text49ly: 'Payment description',
  text4dse: 'Close fault description popup',
  text4dwa: 'Please after mailing',
  text4g8p: 'Your device repair application',
  text4h32: 'Reinspection remark',
  text4kta: 'Popup will appear in',
  text4q11: 'Repair amount',
  text4sjg: 'Current element exceeds current page',
  text4u2y: 'Or changed search criteria',
  text4w53: 'Fill in quote',
  text4xfy: 'Form add',
  text4y7a: 'OrderStatus',
  text583c: 'Device diagnosed by vendor',
  text5cxk: 'Information as follows',
  text5jeq: 'Out-of-warranty repair requires fee',
  text5kpp: 'Chemistry',
  text5lbq: 'Geography',
  text5mne: 'Biology',
  text5ogt: 'Return shipping',
  text5pai: 'Initial diagnosis image',
  text5s9o: 'Otherwise should be default',
  text5sdf: 'Submit in days',
  text5stz: 'Transfer records',
  text5tkq: 'Table data query',
  text5x7e: 'Need to send entire machine',
  text60d9: 'Your submitted',
  text615b: 'Support credit card payment',
  text63rq: 'Table data',
  text646e: 'Repair management',
  text69ag: 'Return shipping',
  text6cgu: 'Dispute description',
  text6kvt: 'Fault description popup',
  text6qhb: 'Machine',
  text6rmc: 'Dynamic cutting',
  text6sgg: 'Out-of-warranty repair requires fee',
  text6vg3: 'Return page number',
  text6vs3: 'Vendor return/exchange',
  text6xfh: 'Quality inspection completed',
  text744d: 'Device needs out-of-warranty repair after vendor diagnosis',
  text7457: 'Subject',
  text759t: 'Out-of-warranty repair',
  text75jj: 'Number to uppercase',
  text75l0: 'Return original machine unrepaired',
  text7gjz: 'Video call records',
  text7gkh: 'Return information',
  text7m03: 'Fault description',
  text7urb: 'And repair payment popup',
  text7wcs: 'If sent with other courier COD',
  text7z8o: 'Frontend hardcoded first',
  text82m7: 'So this must be set to',
  text82n2: 'Get reason not covered by warranty',
  text84k1: 'Repair payment',
  text84xf: 'All set to default',
  text8av1: 'Or changed search criteria',
  text8cva: 'Please select person',
  text8me7: 'Please pack machines or accessories for return properly',
  text8pgz: 'No pass in hold',
  text8qc9: 'Required field initialization',
  text8ri1: 'Pending submit',
  text8sol: 'View repair quote details on page',
  text8uqq: 'Courier company name',
  text8xie: 'Long term',
  text8xvz: 'Reinspection result',
  text8zqy: 'Repair management',
  text8zt7: 'Switch follow-up option',
  text97nv: 'Only applicable',
  text98yq: 'Media is image',
  text9aw1: 'Need to replace and send back',
  text9hs6: 'Test',
  text9i1t: 'Non-warranty reason',
  text9j44: 'Vendor return/exchange',
  text9jj5: 'Or manually clear and click search',
  text9lhk: 'Chemistry',
  text9lns: 'Service center',
  text9m6j: 'Collapse',
  text9shl: 'Out-of-warranty repair requires fee',
  text9tad: 'After-sales address',
  text9uwa: 'Biology',
  texta2iq: 'Or manually clear and click search',
  texta8dx: 'Application',
  textad7l: 'Non-warranty product repair quote',
  textaiqt: 'Cancel repair pending return',
  textajcd: 'Customer submitted',
  textako6: 'Set request parameters',
  textango: 'Courier requirement',
  textapja: 'Foundation building effect',
  textaspy: 'Test description',
  textavdq: 'Sync course accuracy rate',
  textb067: 'Quote description',
  textb2tm: 'Reason',
  textb31s: 'Paid and repairing',
  textb635: 'Dear partner',
  textbbne: 'No tracking info yet',
  textbcwr: 'Repair amount',
  textblwy: 'Repair result',
  textbmh3: 'Thank you for your cooperation',
  textbxrg: 'Review',
  textc6fo: 'Current',
  textc8ye: 'Cost will be at your expense',
  textcczt: 'Get',
  textckrt: 'Quote description',
  textclba: 'Repair vendor',
  textcoch: 'Student application',
  textcos4: 'Non-warranty reason',
  textcpyy: 'Self-pay for damage',
  textcu1q: 'Please select subject',
  textcwbf: 'Short term',
  textcx7z: 'Initial diagnosis result',
  textcz90: 'Modify',
  textd124: 'All accessories and packaging',
  textd4ip: 'Repair payment',
  textd8ty: 'Get fault type',
  textdiws: 'Test description',
  textdjs3: 'Collection',
  textdkbb: 'Expired',
  textdsln: 'Dispute result',
  textdt32: 'Repair management',
  textduw5: 'No more popup',
  textdv5x: 'Repair management',
  textdxc4: 'Repair application and return reminder',
  texte0hp: 'View image',
  texte27e: 'Click clear button',
  texte2as: 'Thank you for your cooperation',
  texte4o5: 'Returned Logistics Info',
  textee6v: 'Dispute',
  texteeeh: 'COD not accepted except SF Express',
  textefhh: 'Math',
  texteifo: 'Table List Display Fields',
  texteusc: 'Export Parameters',
  texteveb: 'Unsubscribe',
  textew1u: 'Then',
  textew8e: 'Return Shipping Info',
  textf2wp: 'Choose Whether to Pay',
  textf35y: 'Device Repair Applications',
  textf6yk: 'Pending Verification',
  textf954: 'Repair Result',
  textf9ay: 'Historical Search Parameters',
  textfb1f: 'Grant',
  textfe65: 'After-sales Repair Reminder',
  textfea8: 'Calculate total height of files to print based on ratio',
  textfgwm: 'Quality Check Passed, Waiting for Return',
  textfhfk: 'English',
  textfotn: 'Device requires out-of-warranty repair after manufacturer diagnosis',
  textfrqk: 'Class Name',
  textfvoj: 'Not Reviewed',
  textfwit: 'Total Paper Height',
  textfy7i: 'Science',
  textfz2w: 'Fault Images',
  textg052: 'New Device',
  textg6c0: 'Please',
  textg735: 'Repair Category',
  textg9iq: 'Device Diagnosed by Manufacturer',
  textgbp2: 'After-sales Repair Reminder',
  textgbzr: 'Due to',
  textge5g: 'Confirmer Signature',
  textgkhx: 'Return to Factory Shipping',
  textgosk: 'Passed',
  textgr7g: 'Unsubscribe',
  textgrxx: 'Proof Not Passed',
  textgtjd: 'WeChat Payment Recommended',
  textgwdb: 'Detection',
  textgyac: 'Horizontal',
  textgzgy: 'Fault Image',
  texth07c: 'Quotation Result',
  texth1uz: 'Device Repair Request(s)',
  texth5tk: 'Thank You for Your Cooperation',
  texth8j6: 'Otherwise Original Device Will Be Considered Not Repaired',
  texthayb: 'No Data No Popup',
  texthed3: 'Preliminary Judgment Based on Product Appearance',
  texthfjq: 'Unit',
  texthgap: 'Product Type',
  texthqio: 'Return Instructions',
  texthr60: 'Unsubscribe',
  texthsad: 'Daily Score Standard Deviation',
  texthsjt: 'Chinese',
  texthsuv: 'OperationType',
  texthxic: 'Number of Answers',
  texti0by: 'Current Page of Traversed Element',
  texti4n0: 'Unsubscribe',
  texti7uy: 'Due to',
  texticu2: 'Click Clear Button',
  textig4p: 'Fetch Data',
  textijzk: 'Common Dialog',
  textikaf: 'Rate Now',
  textikvr: 'Repair Details',
  textir0j: 'Used for Initializing Required Fields',
  textislp: 'Unsubscribe',
  textitx4: 'Thank You',
  textixqc: 'Already Approved',
  textjaby: 'Face Reference Photo',
  textjd4h: 'Not Exceeded',
  textjeoq: 'Dear Partner',
  textjsfe: 'Exported',
  textjxax: 'Need to Resend',
  textk7qh: 'Review',
  textk916: 'Image',
  textk9y5: 'Dear Headquarters Staff',
  textkfxg: 'Manual Follow-up',
  textkgfd: 'All',
  textki4i: 'Process Records',
  textkkko: 'Whether Crossed',
  textkot6: 'Create',
  textkpx4: 'Return Express Information',
  textkqio: 'Set All as Default',
  textkscu: 'Check Logistics Status',
  textkwff: 'Repair Payment',
  textl5vr: 'Original PriceTotal Amount',
  textlfnm: 'Your Device Repair Request',
  textlglu: 'Repair Payment',
  textli61: 'Notes',
  textll3j: 'Correct Answers in Sync Class',
  textlou3: 'New Data',
  textlrf8: 'Personnel',
  textlw09: 'Science',
  textlw5h: 'Unit',
  textlw91: 'Pending Review',
  textlzqa: 'Quality Inspection Notes',
  textm0p2: 'Table Data Query',
  textm3wt: 'Distribution Reason',
  textm4v8: 'Video',
  textm6u6: 'Callback Function',
  textmem9: 'Corresponding Express Fee Needs to Be Borne by You',
  textmgy6: 'Replacement Pending Return',
  textmije: 'Repair Rejected',
  textmiye: 'Subject',
  textmmg0: 'Click Clear Button',
  textmnjq: 'Or Changed Search Criteria',
  textmq6j: 'Collapse',
  textmqah: 'Actual Processing Method',
  textmqmr: 'After-sales Address',
  textmt4o: 'Source Type',
  textmtn7: 'Return Express',
  textmtsi: 'Subject',
  textmwny: 'Repair Request',
  textn1kz: 'Quotation',
  textn6rk: 'As',
  textn8jo: 'Return Information',
  textnd2i: 'Otherwise Should Be Default',
  textnlkg: 'Repair Details',
  textno8d: 'Table Fields',
  textnp6g: 'Customer Phone',
  textnqvz: 'Quality Inspection Image',
  textnwkk: 'Get Search Parameters From',
  textnxhz: 'View Repair Quotation Details on Page',
  textny49: 'If Search Criteria is Empty',
  texto2a1: 'Control Follow-up Record Popup',
  texto2nu: 'Actual Fault Type',
  texto91d: 'All Status Table Columns',
  textocqw: 'Then Use Historical Search Criteria',
  textocuo: 'If You Have Objections',
  textod5b: 'Table Total Count',
  textoh1d: 'Overdue Pickup Will Be Handled Separately',
  texton15: 'Re-inspection',
  textoq1w: 'Calculate If It Exceeds Location',
  textoxa7: 'Student Name',
  textoxlo: 'Your Submitted',
  textp08s: 'Our Repair Center Provides Free Storage for You',
  textp434: 'After Mailing Please',
  textp5mv: 'Service Center',
  textp6kc: 'Build Request Parameters',
  textp709: 'Return Result',
  textp9nw: 'Days to Build Foundation and Overcome Knowledge Gaps',
  textpc7n: 'Number to Words',
  textpcmy: 'Mathematics',
  textphoc: 'Repair Order(s)',
  textphxg: 'Completed',
  textpllk: 'After-sales Staff Will Expedite Processing for You',
  textpo0j: 'Under Repair',
  textpoh2: 'Inspection Image',
  textppwi: 'Geography',
  textpq7v: 'Factory Return Express Information',
  textpsj3: 'Clicked Export',
  textpth9: 'Table Title',
  textpycm: 'Otherwise Should Be Default',
  textpyte: 'Otherwise Should Be Default',
  textpzwi: 'Fault Book Name Read Status',
  textq7tb: 'Contact Address',
  textq803: 'Latest',
  textqda5: 'Contact',
  textqefr: 'Requires Out-of-warranty Repair',
  textqgtm: 'Calculate Current',
  textqj07: 'Manufacturer Return/Exchange',
  textqm88: 'Quality Inspection Status',
  textqyyc: 'Review Status',
  textqz8y: 'Recipient Information',
  textr00k: 'Repair Amount Original Price',
  textr1cq: 'Will Refund Original Repair Payment',
  textr1hc: 'Expand',
  textr1ni: 'Under Repair',
  textr8sg: 'Process Immediately',
  textrab9: 'Get Items to Print',
  textrbki: 'Report',
  textreh6: 'If Empty',
  textrg6y: 'Your Device Repair Request',
  textrj1v: 'Actual Processing Method',
  textrjax: 'Requires Out-of-warranty Repair',
  textrnzc: 'Custom Dialog Reminder',
  textrv31: 'In Possession',
  textrvkf: 'Initial Diagnosis Processing Method',
  texts2sr: 'Or Click Search After Manually Clearing',
  texts5d7: 'Fetch Data',
  texts6oz: 'And Choose Whether to Pay',
  texts82f: 'Fault Type',
  texts9rp: 'Student Recent',
  textsamb: 'Pass',
  textselj: 'Final Judgment Subject to Actual Inspection Results by Repair Personnel',
  textsfmz: 'Table List Display Fields',
  textsh0l: 'After-sales Repair Reminder',
  textsh84: 'Initial Diagnosis',
  textsqsh: 'Display Red',
  textsrm2: 'Service Center',
  textstfk: 'Total Answers in Sync Class',
  textsuj7: 'Disagree with Repair',
  textsxey: 'Review Remarks',
  textt0rw: 'Judgment Condition',
  textt1am: 'Please in',
  textt2ff: 'Choose Whether to Pay',
  textt4uf: 'Or Click Search After Manually Clearing',
  textt611: 'Return Express',
  textt9n0: 'Pending Entry',
  texttaxz: 'Get Repair Details',
  textth1j: 'Image Type and Quality',
  texttllb: 'Repair Evaluation',
  texttrgt: 'Popup Will',
  texttu61: 'Table Merge Fields',
  textucpq: 'If You Have Objections',
  textuczq: 'Unsubscribe',
  textuir4: 'Proof Not Passed',
  textunic: 'If Due to Non-compliant Packaging',
  textutm4: 'Return Express',
  textuw1i: 'Already Shown',
  textv07h: 'Change',
  textv3y4: 'Already Approved',
  textv4jl: 'Set All as Default',
  textvbaq: 'Then',
  textvd87: 'Processing Method for Parents',
  textvdb7: 'Lower Than',
  textvdzu: 'Total Count',
  textves7: 'Initial Diagnosis',
  textvfii: 'Search Form',
  textvflo: 'Mathematics',
  textvg1v: 'Table Data Query',
  textvgmx: 'Full Device Replacement',
  textvms0: 'Repair Category',
  textvo61: 'Day(s) Submitted',
  textvocn: 'Is Part',
  textvrvj: 'Initial Diagnosis Notes',
  textvs5i: 'If There Is',
  textvwq8: 'Aspect Ratio',
  textvx0u: 'After-sales Staff Will Expedite Processing for You',
  textvyzx: 'Fill in Your Express Information on the Page',
  textw07v: 'Chinese',
  textw3lc: 'Select Basic Insurance',
  textw58a: 'Unsubscribe',
  textw84m: 'After-sales Staff Will Expedite Processing for You',
  textw8lj: 'Factory Return Express',
  textwa43: 'Please in',
  textwaad: 'Repair Progress',
  textwf3j: 'Inspection',
  textwhs5: 'Search Criteria Column',
  textwih6: 'Inspection Result',
  textwj2j: 'Re-inspection Result',
  textwjxd: 'Information As Follows',
  textwo1j: 'Repair Quotation',
  textwrja: 'Default',
  textwzxq: 'Agree to Repair',
  textx3li: 'SF Express Collect for Devices Within Normal Warranty',
  textx66h: 'Click Clear Button',
  textx6cv: 'Top Text Prompt',
  textx89t: 'Total Count',
  textxa7k: 'Set All as Default',
  textxaqy: 'Repair Management',
  textxeb0: 'Contact Phone',
  textxefe: 'Device Repair Request(s)',
  textxmip: 'Student Basic Information',
  textxngk: 'But Assume No Other Responsibilities',
  textxqpu: 'Loading Failed',
  textxqvc: 'If Expired Please Contact Dealer or Customer Service to Re-download File',
  textxwh2: 'Popup Will',
  texty0vr: 'Page Size',
  texty3cr: 'No Expired Passes',
  texty880: 'Margin',
  texty8st: 'Repair Instructions',
  textycff: 'Physics',
  textyfdy: 'Search Criteria Column',
  textyo22: 'Total Repair Amount',
  textyt4i: 'Physics',
  textywfr: 'Based on',
  textywx2: 'Payment Result',
  textz14c: 'System Follow-up',
  textz2l6: 'Dou Zhaobin',
  textz2yr: 'Suggested Processing Method',
  textz8e2: 'Verification Info in Request Header, etc.',
  textzc0w: 'Total Count',
  textzc96: 'Or Changed Search Criteria',
  textzefb: 'Enable Fault Description',
  textzfvb: 'Expand',
  textzk14: 'Contact',
  textzk3n: 'Dispute Result',
  textzunm: 'And Choose Whether to Pay',
  textzzes: 'Track',
  threeStarCount: '3-Star',
  time: 'Operation Time',
  tipDuplicateApply: 'The following students have already applied or are in payment. Please change your selection.',
  topicEndTime: 'Topic End Time',
  topicName: 'Topic Name',
  topicStartTime: 'Topic Start Time',
  totalDuration: 'Total',
  totalDurationHours: 'Total Duration (hours)',
  totalQuestionCount: 'Total questions',
  totalQuestionTime: 'Total answering time',
  twoStarCount: '2-Star',
  type: 'Operation Type',
  unbindConfirmTip: 'Confirm to unbind {account} from learning machine? After unbinding, this account cannot use the machine for learning, and subscribed subjects will be invalid immediately.',
  unbindFailed: 'Unbind failed',
  unbindSuccess: 'Unbind successful',
  unfreeze: 'Unfreeze',
  unfreezeSuccess: 'Account unfrozen successfully',
  universalAvailableDurationLabel: 'Universal Available Duration:',
  universalBalance: 'Universal Subscription Balance',
  universalBalanceLabel: 'Universal Duration Balance:',
  universalDurationBalance: 'Universal Duration Balance',
  universalDurationRecharge: 'Universal Duration Recharge',
  unstudyDays: 'Unstudy days',
  unsubscribe: 'Unsubscribe',
  unsubscribeEffective: 'Unsubscribe Effective',
  unsubscribeFailed: 'Unsubscribe failed',
  unsubscribeSuccess: 'Unsubscribed successfully',
  uploadCountLimit9: 'Image/video count must not exceed 9!',
  uploadFail: 'Upload failed',
  uploadFailRetry: 'Upload failed, please retry',
  uploadLimit10Images: 'Upload limit reached, max 10 images',
  uploadLimit9Images: 'Upload limit reached, max 9 images',
  uploadLimitError: 'Upload limit reached. Max 9 images.',
  uploadLimitReached: 'Upload limit reached',
  uploadMediaMax9Count: 'Maximum 9 images/videos allowed!',
  uploadMediaSizeExceed20M: 'Image/video size cannot exceed 20MB!',
  uploadSizeLimit20MB: 'Image/video size must not exceed 20MB!',
  use: 'Use',
  user: 'User Account',
  userAccount: 'User Account',
  userActivityFlag: 'User activity',
  userLabel: 'User',
  userName: 'User Name',
  userNameLabel: 'User Name:',
  userPlaceholder: 'User name/contact',
  validateFailedRetry: 'Validation failed. Please retry.',
  verifyCode: 'Verify Code',
  verifyCodeLabel: 'Verify Code:',
  verifyCodeRequired: 'Verification code is required',
  verifyCodeSendSuccess: 'Verification code sent successfully',
  verifyFailed: 'Verification failed',
  verifyFailedBind: 'Verification failed. Cannot bind student account.',
  videoCount: 'Videos',
  videoDuration: 'Video Duration',
  videoWatchTimeApprox: 'Video watch time (approx.)',
  week: 'Week',
  withdrawApplySuccess: 'Withdraw application successful',
  wu: 'No Review Needed',
  wuyear: 'Grade 5',
  xinma: 'New SN Code',
  xue: 'Chemistry',
  xuema: 'Learning SN Code',
  xueque: 'Post-learning Accuracy',
  xuexiao: 'School',
  year: 'Face 2 Age',
  yesRecognitionStatus: 'Recognition Status',
  yi: 'Repair Info',
  yici: 'Recent Exam Score (Days)',
  yiciday: 'Recent Exam Date',
  yimonthhour: 'Default One Month',
  yiyear: 'Grade 1',
  yongdi: 'Common Location',
  youshi: 'Valid Duration',
  yuan: 'CNY',
  zeroStarCount: 'No Star',
  zongshi: 'Total Answer Time',
  useLandlineOutbound: 'Use landline outbound',
  useMobileOutbound: 'Use mobile outbound',
  birthDate: 'Birth Date:',
  stageGrade: 'Stage/Grade:',
  age: 'Age:',
  gender: 'Gender:',
  adaptiveAccount: 'Adaptive Account:',
  password: 'Password:',
  school: 'School:',
  homeAddress: 'Home Address:',
  remark: 'Remark:',
  source: 'Source:',
  fullTime: 'Full-time:',
  serviceFollowUp: 'Service Follow-up',
  changeSupervisorStatus: 'Change Supervisor Status',
  removeFromServiceCenter: 'Remove from Service Center',
  tabMachineSubscribe: 'Machine Subscribe',
  tabUserRecord: 'User Record',
  tabFollowRecord: 'Follow Record',
  tabGoldDetail: 'Gold Detail',
  tabServiceRelation: 'Service Relation',
  tabSuperviseService: 'Supervise Service',
  tabVideoCall: 'Video Call',
  tabFullTimeDeclare: 'Full-time Declaration',
  changeStudentPassword: 'Change Student Password',
  studentNameFormLabel: 'Student Name:',
  oldPassword: 'Old Password',
  newPasswordLabel: 'Password:',
  newPasswordPlaceholder: 'Enter 6-32 characters, numbers or letters only',
  confirmModify: 'Confirm',
  addFollowRecordTitle: 'Add Follow Record',
  followContent: 'Follow Content:',
  followContentPlaceholder: 'Enter follow content',
  nextFollow: 'Next Follow:',
  nextFollowPlaceholder: 'Select next follow time',
  clickUpload: 'Click to Upload',
  uploadTip: 'JPG/PNG only, max 500KB',
  editCustomerArchive: 'Edit Customer Archive',
  invalidReason: 'Invalid Reason',
  invalidReasonPlaceholder: 'Within 100 characters',
  customerName: 'Customer Name:',
  gender: 'Gender:',
  male: 'Male',
  female: 'Female',
  selectDateTime: 'Select date',
  phoneLabel: 'Phone:',
  homeAddressPlaceholder: 'Enter home address',
  selectSchoolLabel: 'Select School:',
  enterSchool: 'Enter school',
  schoolOptionTip: 'If your school is not in the list, please contact HQ support.',
  sourceLabel: 'Source:',
  stageGradeLabel: 'Stage/Grade:',
  contact1: 'Contact 1:',
  contact2: 'Contact 2:',
  contact3: 'Contact 3:',
  enterPhone: 'Enter phone number',
  nameEditOnce: 'Name can only be edited once',
  stageGradeEditOnce: 'Stage/grade can only be edited once',
  within500Chars: 'Within 500 characters',
  within100Chars: 'Within 100 characters',
  homeAddressLabel: 'Home Address:',
  removeConfirmTip: 'Confirm to remove student ',
  removeConfirmSuffix: ' from service center?',
  removeConfirmDesc: 'After removal, supervision and subscription services will no longer be available for this student.',
  studentNameFormatTip: 'Student name allows Chinese, English letters and separator "·" only.',
  stageGrade_6003004: 'Kindergarten',
  stageGrade_6003001: 'Primary',
  stageGrade_6003002: 'Middle School',
  stageGrade_6003003: 'High School',
  stageGrade_6003005: 'General',
  stageGrade_6004023: 'K1',
  stageGrade_6004024: 'K2',
  stageGrade_6004025: 'K3',
  stageGrade_6004001: 'Grade 1',
  stageGrade_6004002: 'Grade 2',
  stageGrade_6004003: 'Grade 3',
  stageGrade_6004004: 'Grade 4',
  stageGrade_6004005: 'Grade 5',
  stageGrade_6004006: 'Grade 6',
  stageGrade_6004007: 'Grade 7',
  stageGrade_6004008: 'Grade 8',
  stageGrade_6004009: 'Grade 9',
  stageGrade_6004010: 'Grade 10',
  stageGrade_6004011: 'Grade 11',
  stageGrade_6004012: 'Grade 12',
  stageGrade_6004013: 'Grade 13 (Senior 4)',
  stageGrade_6004020: 'General',
  // Batch allocated customer title
  batchAllocatedCustomerTitle: 'Batch Assign Service Person',
  batchAllocatedCustomerStudentName: 'Name',
  batchAllocatedCustomerStageGrade: 'Stage/Grade',
  batchAllocatedCustomerAccountUser: 'Learning Center Account',
  batchAllocatedCustomerServerPeople: 'Service Person',
  // Teacher status filter
  teacherStatusNoLimit: 'No Limit',
  teacherStatusAllocated: 'Assigned',
  teacherStatusPendingAllocate: 'Pending Assign',
  // Follow status filter
  followStatusNoLimit: 'No Limit',
  followStatusNoFollowNeeded: 'No Follow Needed',
  followStatusPendingFollow: 'Pending Follow',
  // Study time daily report
  studyTimeNoLimit: 'No Limit',
  duxueStatusExpiring: 'Supervision Expiring Soon',
  // Yes/No
  yes: 'Yes',
  no: 'No',
  // Customer list related
  customerName: 'Customer Name',
  phoneNumber: 'Phone Number',
  stageGrade294: 'Stage/Grade',
  realNameAuth: 'Real Name Auth',
  passStatus: 'Pass Status',
  syncCourseStatus: 'Sync Course Status',
  servicePerson: 'Service Person',
  learningMachineAccount: 'Learning Machine Account',
  area: 'Area',
  subscribeSubject: 'Subscribe Subject',
  studentName: 'Name',
  stageGrade303: 'Stage/Grade',
  learningCenterAccount: 'Learning Center Account',
  servicePerson305: 'Service Person',
  math: 'Math',
  notHeld: 'Not Held',
  passHeld: 'Pass Held',
  tempPassHeld: 'Temp Pass Held',
  tempPassType: 'Temporary Pass Type',
  notRecommended: 'Not Recommended',
  learnable: 'Learnable',
  notLearnable: 'Not Learnable',
  // index-duxue.vue list related
  customerName255: 'Customer Name',
  phoneNumber256: 'Phone Number',
  userProfile: 'User Profile',
  realNameAuth258: 'Real Name Auth',
  supervisorAccount: 'Supervisor Account',
  supervisorStatus: 'Supervisor Status',
  supervisorValidDate: 'Supervisor Valid Date',
  stageGrade261: 'Stage/Grade',
  fulltime: 'Full-time',
  fulltimeInfoIncompleteTip: "Please complete the student's school and grade information before applying.",
  goDeclare: 'Go to Declare',
  fulltimeType1Tip: '(≥5 hours)',
  fulltimeType2Tip: '(≥25 hours)',
  passStatus263: 'Pass Status',
  syncCourseStatus264: 'Sync Course Status',
  servicePerson265: 'Service Person',
  learningMachineAccount266: 'Learning Machine Account',
  area267: 'Area',
  subscribeSubject268: 'Subscribe Subject',
  profileCompleted: 'Completed',
  profileNotCompleted: 'Not Completed',
  math281: 'Math',
  notHeld282: 'Not Held',
  passHeld283: 'Pass Held',
  tempPassHeld284: 'Temp Pass Held',
  notRecommended285: 'Not Recommended',
  learnable286: 'Learnable',
  notLearnable287: 'Not Learnable',
  inviteTransfer: 'Invite Transfer',
  loadFailed: 'Load Failed',
  batchAssignServicePerson508: 'Batch Assign Service Person',
  // Subject
  chinese: 'Chinese',
  math2: 'Math',
  english: 'English',
  chemistry: 'Chemistry',
  physics: 'Physics',
  // Weekly report
  analystWeeklyReport: 'Analyst Service Indicators Weekly Report',
  // Video call record
  videoCallRecord: 'Video Call Record',
  // Cross entity supervision application
  newApplication: 'New Application',
  detail: 'Detail',
  quotaNotExceeded: 'Monthly Quota Not Exceeded',
  crossEntityDevice: 'Your Cross-entity Device Student Has',
  noNeedApply: 'No Need to Apply in Current Status',
  crossEntityStudentNameAccount: 'Student Name / Account',
  pleaseEnterCrossEntityStudentNameAccount: 'Enter student name or account',
  crossEntityApplyStatus: 'Application Status',
  pleaseSelectCrossEntityApplyStatus: 'Please select application status',
  crossEntityApplyStatusPending: 'Pending Review',
  crossEntityApplyStatusApproved: 'Approved',
  crossEntityApplyStatusRejected: 'Review Rejected',
  crossEntitySubmitTime: 'Application Submit Time',
  crossEntityStudentName: 'Student Name',
  crossEntityStudentAccount: 'Student Account',
  crossEntityDealerId: 'Device Dealer ID',
  crossEntityDealerName: 'Device Dealer Name',
  crossEntitySubmitter: 'Submitter',
  crossEntityAuditTime: 'Audit Time',
  crossEntityAuditor: 'Auditor',
  auditOpinion: 'Audit Opinion',

  // Cross-entity supervision application dialog (dedicated keys)
  crossEntityDialogTitleCreate: 'New cross-entity supervision application',
  crossEntityDialogTitleView: 'Cross-entity supervision application details',
  crossEntityDialogTitleAudit: 'Review cross-entity supervision application',
  crossEntityDialogTitleFallback: 'Cross-entity supervision application',
  crossEntityDialogGuideLine1:
    'When the device purchased by the student is not under your same-entity dealer, the student is supervised across entities.',
  crossEntityDialogGuideLine2:
    'To transfer such students for service, submit for review and wait for provincial approval before transfer.',
  crossEntityDialogStudentAccountPlaceholder: 'Enter student account',
  crossEntityDialogSituationDescription: 'Situation description',
  crossEntityDialogSituationPlaceholder:
    'Enter situation description (5–200 characters)',
  crossEntityDialogProofDocuments: 'Supporting documents',
  crossEntityDialogUploadProofHint:
    'Upload proof of supervision service purchase and communication records with parents',
  crossEntityDialogClickUploadImage: 'Click to upload image',
  crossEntityDialogProofImageAlt: 'Supporting document',
  crossEntityDialogTransferServiceCenterId: 'Transfer-in service center ID',
  crossEntityDialogTransferServiceCenterName: 'Transfer-in service center name',
  crossEntityDialogAuditResult: 'Audit result',
  crossEntityDialogAuditStatus: 'Audit status',
  crossEntityDialogSelectAuditResult: 'Select audit result',
  crossEntityDialogAuditOptionApprove: 'Approved',
  crossEntityDialogAuditOptionReject: 'Rejected',
  crossEntityDialogAuditRemarkPlaceholder: 'Enter audit comments',
  crossEntityDialogBtnClose: 'Close',
  crossEntityDialogBtnCancel: 'Cancel',
  crossEntityDialogBtnSubmitAudit: 'Submit review',
  crossEntityDialogBtnSubmitApply: 'Submit application',
  crossEntityDialogRuleStudentAccount: 'Please enter student account',
  crossEntityDialogRuleDescriptionRequired:
    'Please enter situation description',
  crossEntityDialogRuleDescriptionLength:
    'Situation description must be 5–200 characters',
  crossEntityDialogRuleEvidence: 'Please upload supporting documents',
  crossEntityDialogRuleAuditResult: 'Please select audit result',
  crossEntityDialogRuleAuditRemark: 'Please enter audit comments',

  // Repair request related
  repairRequest392: 'Repair Request',
  faultType412: 'Fault Type',
  faultType411: 'Fault Type',
  detailedDescription413: 'Detailed Description',
  operation414: 'Operation',
  modify393: 'Modify',
  review394: 'Review',
  returnFactoryExpress395: 'Return Factory Express',
  initialDiagnosis396: 'Initial Diagnosis',
  detection397: 'Detection',
  fillQuotation398: 'Fill Quotation',
  repairPayment399: 'Repair Payment',
  underRepair400: 'Under Repair',
  qualityInspection401: 'Quality Inspection',
  returnExpress402: 'Return Express',
  detail403: 'Detail',
  reinspectionResult404: 'Reinspection Result',
  disputeResult405: 'Dispute Result',
  correctNewSNCode406: 'Correct New SN Code',
  evaluate407: 'Evaluate',
  evaluateServiceHere197: 'Evaluate this service here',
  correctNewSNCode415: 'Correct New SN Code',
  agentID408: 'Agent ID',
  agentName409: 'Agent Name',
  learningMachineSNCode410: 'Learning Machine SN Code',
  pleaseEnterNewSNCode416: 'Please enter new SN code',
  // Common buttons
  cancel: 'Cancel',
  confirm: 'Confirm',
  confirm2: 'OK',
  submit: 'Submit',

  // Learning machine account student
  operation32: 'Operation',
  subscribeSubjectManage1: 'Subscribe Subject Management',
  unbind2: 'Unbind',
  unbindRelation: 'Unbind Relation',
  submitInformation3: 'Submit Information',
  withdrawApplication4: 'Withdraw Application',
  subscribeSubjectManage17: 'Subscribe Subject Management',
  studentAccount45: 'Student Account',
  studentName38: 'Student Name',
  serviceCenterId39: 'Service Center ID',
  serviceCenterName40: 'Service Center Name',
  machineAccount47: 'Machine Account',
  learningArea23: 'Learning Area',
  generalAvailableDuration24: 'General Available Duration',
  areaDuration25: 'Area Duration',
  agentId48: 'Agent ID',
  agentName49: 'Agent Name',
  subject28: 'Subject',
  machineSubscribeStatus29: 'Subscription Status',
  recentSubscribeCancelDate30: 'Recent Subscribe/Cancel Date',
  currentStudyEndDate31: 'Current Study End Date',
  operation16: 'Operation',
  cancelUnsubscribe15: 'Cancel Unsubscribe',
  unsubscribe16: 'Unsubscribe',
  subscribe17: 'Subscribe',
  unsubscribeEffective5: 'Unsubscribe Effective',
  unsubscribe6: 'Unsubscribe',
  subscribe7: 'Subscribe',
  unsubscribeEffective8: 'Unsubscribe Effective',
  submitMaterial33: 'Submit Material',
  machineAccount34: 'Machine Account',
  dealerId35: 'Dealer ID',
  dealerName36: 'Dealer Name',
  studentAccount37: 'Student Account',
  studentName19: 'Student Name',
  serviceCenterId20: 'Service Center ID',
  serviceCenterName21: 'Service Center Name',
  applicationNote41: 'Application Note',
  newStudentName42: 'New Student Name',
  newStudentFacePhoto43: 'New Student Face Photo',
  proofMaterial44: 'Proof Material',
  proofUploadTip9: 'Please upload proof that the child using the machine is from the same family. Supports jpg/png, max 20MB',
  slotTipStyleColorRedFontSize110: 'images',
  save11: 'Save',
  save: 'Save',
  textx02y: 'Purchase amount:',
  textfl9n: 'Save and pay',
  subscribeConfirm18: 'Subscribe Confirm',
  unsubscribeConfirm19: 'Cancel Subscribe',
  studentAccount18: 'Student Account',
  studentName46: 'Student Name',
  machineAccount22: 'Machine Account',
  agentId26: 'Agent ID',
  agentName27: 'Agent Name',
  thisSubscribeSubject20: 'This Subscribe Subject',
  thisUnsubscribeSubject21: 'This Unsubscribe Subject',
  thisDeductDuration22: 'This Deduct Duration',
  thisReturnDuration23: 'This Return Duration',
  month24: 'months',
  confirmUnsubscribe12: 'Confirm to unsubscribe?',
  confirmWithdrawApply13: 'Confirm to withdraw this application?',
  confirmUnbind15: 'Are you sure you want to unbind the student from the service center?',
  confirmUnbind14: 'Confirm to unbind?',
  studentName40: 'Student Name',
  grantUser: 'Grant User',
  grantReason: 'Grant Reason',
  nextCommunicateTime: 'Next Communication Time',
  // Student Whole Analysis
  ddjValidStudyTime: 'DDJ Valid Study Time (Last 180 Days)',
  supervisorNumOverTwo: 'Supervisors with 2+ Score Submissions (Last 180 Days)',
  examScoreUpRate: 'Exam Score Improvement Rate (Last 180 Days)',
  avgUpScore: 'Average Score Improvement (Last 180 Days)',
  year: 'Year',
  day: 'Day',
  teacherImproveStatYear: 'Statistics year',
  teacherImprovePleaseSelectStatYear: 'Please select statistics year',
  teacherImproveStatDay: 'Statistics day',
  teacherImprovePleaseSelectStatDay: 'Please select statistics day',
  teacherImproveAnalystLabel: 'Analyst',
  teacherImprovePleaseEnterAnalyst: 'Enter analyst',
  teacherImproveDdjValidHoursFull: 'DDJ valid study hours (last 180 days, unit: hours)',
  teacherImproveDdjBandLow: 'Below 60 hours',
  teacherImproveDdjBandMid: '60–120 hours',
  teacherImproveDdjBandHigh: 'Above 120 hours',
  teacherImproveEnterDuration: 'Enter duration',
  // Mall related
  coinMall: 'Coin Mall',
  pickupStore: 'Pickup Store',
  providePickupExchange: 'Provide pickup store product exchange function',
  pickupExchangeDesc: 'After enabling the pickup store product exchange function, your students can place orders in the pickup store. After placing an order, you need to provide the corresponding physical product to the student and confirm the exchange in the agent mini-program order management. After confirming the exchange, the order\'s coins will be settled to you.',
  pickupStoreDisplaySetting: 'Pickup Store Display Settings',
  productName: 'Product Name',
  enterProductName: 'Enter Product Name',
  displaySwitchDesc: 'The display switch (will show in the pickup store when enabled)',
  productImage: 'Product Image',
  exchangePrice: 'Exchange Price',
  operation: 'Operation',
  enableSuccess: 'Enabled Successfully',
  disableSuccess: 'Disabled Successfully',
  // customServiceRemind.vue repair reminder dialog
  submittedDeviceRepairApplication: 'Your submitted device repair application',
  deviceDiagnosedByVendorNeedRepair: 'Device has been diagnosed by the vendor and requires out-of-warranty repair',
  deviceDiagnosedByVendor: 'Device has been diagnosed by the vendor',
  outOfWarrantyRepairRequiresFee: 'Since out-of-warranty repair requires a fee, please go to',
  pleaseGoToRepairManagement: '[Service Center] - [Repair Management] - [',
  repairPayment: 'Repair Payment',
  completePaymentWithin: '] page to view the repair quotation details and choose whether to pay. If you have any objections, please contact customer service promptly.',
  pleaseMailDeviceToServiceCenter: '1. Please mail the device to the after-sales center. Details are as follows:',
  address: 'Address',
  afterMailingPleaseGoTo: '2. After mailing, please go to [Service Center] - [Repair Management] - [',
  returnFactoryExpress: 'Return Factory Express',
  fillExpressInfo: '] page to fill in your express info and return info.',
  deviceRepairApplications: 'device repair application(s)',
  hasBeenApproved: 'has been approved.',
  pleaseTimelyReturnProcess: 'Please process return in time',
  pleaseTimelyRepairProcess: 'Please process repair in time',
  // statusHandleMap textKey
  repairRejected: 'Repair Rejected',
  needReplacementSendBack: 'Need to replace and send back',
  qualityInspectionCompleted: 'Quality inspection completed',
  paymentCompleted: 'Payment completed',
  processImmediately: 'Process Immediately',
  customerSubmitted: 'Customer submitted',
  repairOrders: 'repair order(s)',
  thankYouForYourCooperation: 'Thank you for your cooperation. Our after-sales staff will process it as quickly as possible!',
  auto_2_34b654fd: 'Confirm',
  auto_58_e09984a9: 'Select agent',
  auto_59_33616ce3: 'Product Name',
  auto_60_9be5101c: 'Unit Price',
  auto_61_19561ec4: 'Quantity',
  auto_62_183c5153: 'Amount',
  auto_63_33c01edb: 'Pay Serial No.',
  auto_64_9f188f91: 'Pay Method',
  auto_65_e6f5f651: 'Pay Time',
  auto_66_64fdfb77: 'SelectAdd Goods',
  auto_66_fdba32b0: 'Pay Amount',
  auto_67_a43a4a56: 'Operator',
  auto_67_e4534610: 'Goods Detail',
  auto_68_399f575c: 'Dispatch Date',
  auto_68_ebd45720: 'Delete',
  auto_69_29f94f29: 'Express Company',
  auto_69_fd2821fc: 'Payment Detail',
  auto_70_736b7933: 'Prepaid Freight Detail',
  auto_70_9406d319: 'Express No.',
  auto_71_06c824a3: 'Logistics Detail',
  auto_71_1ce95229: 'Logistics Status',
  originalPriceTotalLabel: 'Original price total: ',
  auto_072_88aee664: 'Discount',
  auto_72_1f5e0a58: 'Send Qty',
  auto_73_5a28bf46: 'Charge Item',
  auto_73_f7ef2a1e: 'Purchase Amount',
  auto_74_416952d0: 'Save',
  auto_74_69d68a8d: 'Unit Price',
  auto_75_bee9082e: 'Save & Pay',
  auto_75_fafdc271: 'Quantity',
  auto_76_3fc37ef1: 'yang jiSubscription Cardpei jianPlease selectHQDeliver',
  auto_76_ba853d4f: 'Amount',
  auto_77_13dfff6e: 'shi fou bian gengDispatch TypeweiHQDeliver',
  auto_77_326b6100: 'Discount',
  auto_78_cd7bfcc4: 'Label',
  auto_78_f412d8c2: 'Label',
  auto_79_c325b4aa: 'shi fou bian gengDispatch TypeweiRegion AgentDeliver',
  auto_80_a0a4046f: 'Tip',
  auto_81_b96fa279: 'ConfirmDeletema',
  auto_82_584d7703: 'Tip',
  auto_83_04f546f7: 'Purchase Order No.',
  auto_84_724cbd8c: 'Purchase Unit',
  auto_85_7fa04e5d: 'Purchase Unit',
  auto_86_195870b1: 'Created By',
  auto_87_37398fc9: 'purchaseType',
  auto_88_b04a7574: 'Select purchase type',
  auto_89_56d260b6: 'Shipment Region Agent',
  auto_90_dfdce47a: 'Consignee',
  auto_91_2aac4e29: 'Receiver Phone',
  auto_92_fb3a2700: 'Province/City/District',
  auto_93_8fbb42a4: 'Dispatch Type',
  auto_94_6e065e4b: 'Select dispatch type',
  auto_95_829a762a: 'Shipment Region Agent',
  auto_96_a8f51346: 'Agent Warehouse',
  auto_97_9b94a9cf: 'Agent Warehouse',
  auto_98_9cae1144: 'Select agent warehouse',
  auto_99_7e4f7bcf: 'Delivery Address',
  auto_100_1d863d17: 'Enter campus address',
  auto_101_d439e55b: 'Remark',
  auto_102_26f2fe11: 'Enter remark200zi yi nei',
  auto_103_31b2b61a: 'Operation',
  auto_104_2faa36a6: 'Add Goods',
  auto_105_d0cf4135: 'Confirm',
  auto_9_b8e50bf2: 'uploadCountLimit',
  auto_137_f04bdc99: 'Upload fault imagejiConfirmxu fan chang de ke fu liao tianRecordfou ze jiang bu hui beiPassed',
  auto_138_f9f1009e: 'Label',
  auto_139_54f25dde: 'Agree',
  auto_140_0f33945c: 'Label',
  auto_141_49f1d688: 'ben diFileUpload',
  auto_142_3028f9de: 'pai sheImageVideo',
  auto_143_3ffe7afc: 'Repair Order No.',
  auto_144_25b3044c: 'Enter device SN',
  auto_145_51359635: 'Product Type',
  auto_146_f1fd1dab: 'First timeHardware Activate Time',
  auto_147_4e09be31: 'Hardware Activate Time',
  auto_148_ff67d8df: 'Software Activate Time',
  auto_149_e5e59bbf: 'Dealer Info',
  auto_150_8216ecc6: 'shang ci wei xiuTime',
  auto_151_1f7b6981: 'huan xinValidTime',
  auto_152_2a3d0b25: 'Ship Time',
  auto_153_285a56ac: 'bao xiuValidTime',
  auto_154_ca0155a1: 'Label',
  auto_155_ae7b9eab: 'Please selectyu gu gu zhang fen lei',
  auto_156_01e9401f: 'Detailed Description',
  auto_157_f63eef9f: 'EnterDetailed Description400zi yi nei',
  auto_158_277fad1a: 'Upload ImageVideo',
  auto_159_c5f35bbc: 'Initial Diagnosis Processing Method',
  auto_160_0fd0f923: 'Initial Diagnosis Processing Method',
  auto_161_0e7074d3: 'Initial Diagnosis Processing Method',
  auto_162_31a2cef4: 'Initial Diagnosis Processing Method',
  auto_163_c4fff688: 'Initial Diagnosis Processing Method',
  auto_164_53e12b78: 'Initial Diagnosis Processing Method',
  auto_165_23adb576: 'New SN Code',
  auto_166_c174c9ae: 'Enter new SN code',
  auto_167_135f0459: 'Actual Processing Method',
  auto_168_09e3182c: 'Select actual handling method',
  auto_169_82c84a87: 'Express Company',
  auto_170_b564cbf5: 'Select express company',
  auto_171_285012b1: 'Express No.',
  auto_172_a9b0d47b: 'Enter express no.',
  auto_173_e2ab3dbb: 'Return Result',
  auto_174_24572297: 'Return imagesVideo',
  auto_175_4b33805e: 'Reinspection remark',
  auto_176_47f30660: 'Enter remark400zi yi nei',
  auto_177_5b24c14c: 'Purchase Order No.',
  auto_177_eb22414a: 'Upload ImageVideo',
  auto_178_21da1dc7: 'device',
  auto_179_ea268695: 'Reinspection result',
  auto_180_b0944925: 'Dispute result',
  auto_181_fb5da079: 'Passed',
  auto_182_210ff69d: 'Normal',
  auto_183_fa970116: 'buPassed',
  auto_184_147c7ae0: 'Label',
  auto_185_9217b812: 'Repair RequestCreate',
  auto_186_b8cb9234: 'Repair RequestEdit',
  auto_187_dcb316c0: 'Repair RequestReview',
  auto_188_38add320: 'Repair RequestReturn shipping',
  auto_189_8f2748d7: 'Repair RequestRepair result',
  auto_190_02e41171: 'Repair RequestDetail',
  auto_0_3a534d59: 'Payment details',
  auto_07_84b8cb39: 'Product details',
  auto_9_32922692: 'Confirm',
  auto_30_66c32371: 'Select agent',
  auto_31_fb14aa99: 'Product Name',
  auto_32_b73ee84e: 'Unit Price',
  auto_33_1fd9eecb: 'Quantity',
  auto_34_c7372f4b: 'Amount',
  auto_35_940b0b37: 'Pay Serial No.',
  auto_36_8ef52a37: 'Pay Method',
  auto_37_b298f65c: 'Pay Time',
  auto_38_7c7db366: 'Pay Amount',
  auto_39_f8adeb50: 'Operator',
  auto_40_616e090e: 'Dispatch Date',
  auto_41_f852f988: 'Express Company',
  auto_42_bdc73ed5: 'Express No.',
  auto_43_3ae78086: 'Logistics Status',
  auto_44_2fde8375: 'Send Qty',
  auto_45_fff8ea33: 'Charge Item',
  auto_46_5e69feaa: 'Unit Price',
  auto_47_702b7486: 'Quantity',
  auto_48_76602ef3: 'Amount',
  auto_49_2585ba0c: 'Discount',
  auto_50_2ebed531: 'Back',
  auto_50_a903f791: 'Right Name',
  auto_51_3a73d270: 'Applicable Product',
  auto_51_e10d28d3: 'yang jiSubscription Cardpei jianPlease selectHQDeliver',
  auto_52_1a757eb0: 'Expiry Time',
  auto_52_3e45d83a: 'shi fou bian gengDispatch TypeweiHQDeliver',
  auto_53_26611724: 'gai xian liangModelPlease selectHQDeliver',
  auto_53_9b30d563: 'Right Code',
  auto_54_18949a2d: 'shi fou bian gengDispatch TypeweiHQDeliver',
  auto_54_acf748ec: 'Label',
  auto_55_49aa702e: 'Label',
  auto_55_c47ac8b0: 'Label',
  auto_56_585eb833: 'Label',
  auto_56_846572c6: 'shi fou bian gengDispatch TypeweiRegion AgentDeliver',
  auto_57_52a50233: 'ConfirmDeletema',
  auto_57_d944fc10: 'Enterxiang xiDelivery Addressli',
  auto_58_3f4e6ee4: 'Purchase Order No.',
  auto_59_65f26a9f: 'Purchase Unit',
  auto_60_9ee15081: 'Purchase Unit',
  auto_61_6a47425d: 'Created By',
  auto_62_ea1fd711: 'Remark',
  auto_63_01613afe: 'Enter remark200zi yi nei',
  auto_64_3b8387c1: 'Custom Discount Amount',
  auto_65_684b34d9: 'Enter custom discount amount',
  auto_212_03d121d3: 'Label',
  auto_227_79173d00: 'English',
  auto_228_9e8950ed: 'Mathematics',
  auto_229_06438c2d: 'Chinese',
  auto_230_4952764d: 'Subject',
  auto_231_6b85c456: 'chunFinal',
  auto_232_cbe7d02c: 'qiuMidterm',
  auto_233_4fc7a003: 'Label',
  auto_234_6c77e952: 'da ji chu zongValid Duration',
  auto_235_8a4c4bb7: 'Label',
  auto_236_74a41eaf: 'Label',
  auto_237_bddc5b89: 'Subject',
  auto_238_8aa4d192: 'Foundation Effective',
  auto_239_2011eb2e: 'Label',
  auto_240_6e635316: 'Label',
  auto_241_a7c191fd: 'Label',
  auto_242_35bd356d: 'Label',
  auto_243_ffa5de49: 'Label',
  auto_244_4144d920: 'Label',
  auto_245_e36e402a: 'Completed',
  auto_246_721fbde9: 'Label',
  auto_247_cc41d671: 'Question countliang',
  auto_248_1ee0cfc4: 'Label',
  auto_249_87dcabb7: 'Label',
  auto_250_4ace5df9: 'Label',
  auto_251_31b81bd5: 'Label',
  auto_252_5bb13c93: 'Label',
  auto_429_91696a48: 'Total Score',
  auto_430_6ca0eb76: 'geSubjectzong ti fen',
  auto_431_0bdf2f07: 'Label',
  auto_432_68944296: 'Valid Durationfen',
  auto_433_9a2d44cd: 'Label',
  auto_434_99402a59: 'text100text',
  auto_435_fd6be6e4: 'kuaStagebu chang xi shu1225qiuMidtermshi bu chang hou de fen',
  auto_436_e6d00004: 'SubjectFoundation60h',
  auto_437_27cd212a: 'ti fenScorebu ji ru zui zhong de pai ming ji suan',
  auto_438_bba362ca: 'Foundation Effectivefen man fen100fen',
  auto_439_934cfbdf: 'Statistics Period2025nian7yue10ri8yue31ri',
  auto_440_e470f698: 'xi tong biao xian fen man fen20fen',
  auto_441_638f0ef4: 'Statistics Period2025nian7yue10ri8yue31ri',
  auto_442_cc42a56e: 'Label',
  auto_443_44dd07d6: 'hen yi han zai ben ciActivityqi jian25nian7yue10ri8yue31ri bing mei you jin xing da ji',
  auto_6004010_a35dd9bd: 'stageGrade',
  auto_6004011_dac05942: 'stageGrade',
  auto_6004012_ca4537e1: 'stageGrade',
  auto_244_8afebfce: 'Repair Amount Original Price',
  auto_245_b99f79ba: 'Discount',
  auto_246_762a0a77: 'Total repair amount',
  auto_247_24d7527d: 'Repair QuotationDownload',
  auto_248_ee3fba3a: 'Payment',
  auto_249_780e6b9b: 'Label',
  auto_250_1ca1a70f: 'ju xiuReturn Back',
  auto_251_7ce21dc7: 'Label',
  auto_252_30e634c3: 'text2text',
  auto_253_08309e32: 'WeChat Payment Recommended',
  auto_254_cd68e88a: 'Support credit card payment',
  auto_255_90e9650e: 'Use WeChat Pay',
  auto_256_e05908ce: 'Label',
  auto_257_b27d66fa: 'Refresh',
  auto_258_bb6cd229: 'chong xinGet',
  auto_259_9c2853a7: 'Suggested Handling Method',
  auto_260_1fa1dfa2: 'Select suggested handling method',
  auto_261_6e4da30e: 'Actual Processing Method',
  auto_262_06dc2702: 'Select actual handling method',
  auto_263_13c93438: 'Actual fault type',
  auto_264_513d1204: 'Select fault classification',
  auto_265_f08753b4: 'Non-warranty reason',
  auto_266_5bf5f7c5: 'Select non-warranty reason',
  auto_267_9f460522: 'Repair Instructions',
  auto_268_939e0a95: 'No.',
  auto_269_7a7810c0: 'Repair Category',
  auto_270_866f0b5a: 'Repair Details',
  auto_271_00597f11: 'Repair amount',
  auto_272_b34f6e2c: 'Repair amount',
  auto_273_52546a8d: 'Payment description',
  auto_274_d28a4ee8: 'EnterPayment description400zi yi nei',
  auto_275_4945136b: 'Payment Result',
  auto_276_b6d570db: 'Pay',
  auto_359_47a2c2df: 'Repair Amount Original Price',
  auto_360_ddcd3bef: 'Discount',
  auto_361_b53ab372: 'Total repair amount',
  auto_362_2f99307c: 'Repair QuotationDownload',
  auto_363_1fa20160: 'Agree',
  auto_364_3892d1b5: 'Label',
  auto_365_22d8e02c: 'Suggested Handling Method',
  auto_366_dc6be558: 'Select suggested handling method',
  auto_367_9e5d1345: 'Actual Processing Method',
  auto_368_99d9acb0: 'Select actual handling method',
  auto_369_2de8cffa: 'Actual fault type',
  auto_370_cd112b3f: 'Select fault classification',
  auto_371_a50c5719: 'Non-warranty reason',
  auto_372_430d63b6: 'Select non-warranty reason',
  auto_373_9334412f: 'sNma',
  auto_374_48ca1fa7: 'Enter SN code',
  auto_375_bc903cbb: 'Repair Details',
  auto_376_e8e7b1b1: 'No.',
  auto_377_51e94756: 'Repair Category',
  auto_378_c18dccdf: 'Repair Details',
  auto_379_3295bba5: 'Repair amount',
  auto_380_6326e534: 'Repair amount',
  auto_381_769fd351: 'Suggested Handling Method',
  auto_382_10ff1bd1: 'Select suggested handling method',
  auto_383_8ba4344d: 'Actual Processing Method',
  auto_384_d0647bff: 'Select actual handling method',
  auto_385_e8918b8d: 'Actual fault type',
  auto_386_0f690b76: 'Select fault classification',
  auto_387_a572d6f2: 'sNma',
  auto_388_86557d8e: 'Enter SN code',
  auto_389_106ff316: 'Repair Instructions',
  auto_390_f010e885: 'EnterRepair Instructions400zi yi nei',
  auto_391_257f1d36: 'Repair result',
  auto_0_ce0535cf: 'auto_269_7a7810c',
  auto_2_037c31fd: 'auto_260_1fa1dfa',
  auto_3_a4526aa1: 'auto_252_30e634c',
  auto_4_1affe025: 'auto_265_f08753b',
  auto_5_058edb1d: 'auto_266_5bf5f7c',
  auto_7_04ce20b4: 'auto_259_9c2853a',
  auto_7_06d7f018: 'auto_251_7ce21dc',
  auto_8_1fd88c87: 'auto_274_d28a4ee',
  auto_11_38b63b7f: 'auto_271_00597f',
  auto_32_5300778b: 'auto_253_08309e',
  auto_77_df26ef91: 'auto_246_762a0a',
  auto_95_c8654dd5: 'auto_268_939e0a',
  auto_229_623ff621: 'auto_258_bb6cd',
  auto_1204_0527e8b9: 'auto_264_513d',
  auto_2702_84722670: 'auto_262_06dc',
  auto_93438_a86b9958: 'auto_263_13c',
  auto_460522_c46627d1: 'auto_267_9f',
  auto_0_daf1dd54: 'auto_368_99d9acb',
  auto_1_0823eb8e: 'auto_382_10ff1bd',
  auto_1_9070e5ca: 'auto_376_e8e7b1b',
  auto_2_845314ef: 'auto_387_a572d6f',
  auto_5_2642db25: 'auto_379_3295bba',
  auto_5_ccf0b2ca: 'auto_364_3892d1b',
  auto_6_7a1f1b69: 'auto_372_430d63b',
  auto_7_48789045: 'auto_374_48ca1fa',
  auto_36_abfdc9c9: 'auto_391_257f1d',
  auto_76_a732542a: 'auto_386_0f690b',
  auto_316_5747370f: 'auto_389_106ff',
  auto_351_c6b73e7a: 'auto_381_769fd',
  auto_372_9a3c1d7d: 'auto_361_b53ab',
  auto_534_729c0a98: 'auto_380_6326e',
  auto_558_de3ba6e7: 'auto_366_dc6be',
  auto_885_71a4f1a4: 'auto_390_f010e',
  auto_1345_4f27ef33: 'auto_367_9e5d',
  auto_5719_861a1057: 'auto_371_a50c',
  auto_20160_ba633b06: 'auto_363_1fa',
  auto_94756_d52a8e4d: 'auto_377_51e',
  auto_27_b61fc526: 'text3u',
  auto_79_dc062f24: 'Noneshen baoInformation',
  auto_80_9a7d8dda: 'Pending',
  auto_81_ead4d6ba: 'Label',
  auto_82_e97486ea: 'Passed',
  auto_83_8f5338a9: 'xie yiImage',
  auto_84_f3a42535: 'Start Date',
  auto_85_6ca0f371: 'End Date',
  auto_86_1dc00c5a: 'Preview',
  auto_87_8f7f1a88: 'shen baoType',
  auto_88_0f7b6792: 'shen baoValidity Period',
  auto_89_6a3150fb: 'shen baoTime',
  auto_90_124fbfdc: 'Label',
  auto_91_7e8833e7: 'shen baoStatus',
  auto_92_51c9c127: 'Operation',
  auto_93_2806a664: 'shen baoDetail',
  auto_94_6703c8bb: 'Label',
  auto_95_4ebaf41d: 'Pending',
  auto_96_891981ef: 'shen baoSuccess',
  auto_97_4b83a8c3: 'Audit Reject',
  auto_98_9fc5b955: 'zai ciSubmit',
  auto_99_f3974dc0: 'jia riFull-time',
  auto_100_fba7f4c6: 'li xiaoFull-time',
  auto_106_4d6d84e4: 'jia riFull-time',
  auto_107_1a3ae998: 'li xiaoFull-time',
  auto_108_10a5fc1e: 'wu bi yaoUploadxie yi zhong de guan jian ye',
  auto_109_75af8eab: '2Full-timexue xi de kai shi he jie shuTimeheFillbu yi zhi hui bei bo hui',
  auto_110_5f31333c: 'shen baoValidity Period',
  auto_111_d4b3ffe4: 'Operation',
  auto_112_348a9ed7: 'Full-timeType',
  auto_113_eb7cefd1: 'Full-timeqi zhiDate',
  auto_114_ee10a1d6: 'qian shu deFull-timexie yi',
  auto_115_b799aa8a: 'Preview',
  auto_195_33d0c0b0: 'Purchase Order No.',
  auto_196_50634837: 'device SN：',
  auto_317_c4d8c876: 'Upload fault imagejiConfirmxu fan chang de ke fu liao tianRecordfou ze jiang bu hui beiPassed',
  auto_318_e5664070: 'Label',
  auto_319_ca8fd6e8: 'Agree',
  auto_320_9a8115d0: 'Label',
  auto_321_f3f42745: 'Repair Order No:',
  textxo9n: 'Flow Record:',
  auto_322_f62ecded: 'Enter device SNPurchase Order No',
  auto_323_21724802: 'Product Type:',
  auto_324_1079117f: 'First timeHardware Activate Time:',
  auto_325_1cd0fb06: 'Hardware Activate Time:',
  auto_326_4dcbe91d: 'Software Activate Time:',
  auto_327_af652602: 'Dealer Info:',
  auto_328_455fdaa4: 'shang ci wei xiuTime:',
  auto_329_f6b5c503: 'huan xinValidTime:',
  auto_330_e440e0ab: 'Ship Time:',
  auto_331_00f8b802: 'bao xiuValidTime:',
  auto_332_0c473955: 'Label:',
  auto_333_d5c04f90: 'Please selectyu gu gu zhang fen lei',
  auto_334_78609b66: 'Detailed Description:',
  auto_335_e921ea31: 'EnterDetailed Description400zi yi nei',
  auto_336_c0d5b479: 'Upload ImageVideo:',
  auto_337_1f51f868: 'Audit Result:',
  auto_338_7d752935: 'Repair vendor:',
  auto_339_8572df53: 'Please selectApply Type:',
  auto_340_0b74be28: 'Suggested Handling Method:',
  auto_341_8d46ee87: 'Select suggested handling method:',
  auto_342_d35a428e: 'Audit Remark:',
  auto_343_57dbe80e: 'Enter audit remark400zi yi nei:',
  auto_178_a2a89126: 'Label:',
  auto_179_8fedbfef: 'wei xiuDonehoudeviceji huiAddress:',
  auto_180_81a0f685: 'textProcesstext:',
  auto_181_8d94fe0c: 'Repair Vendor:',
  auto_182_dc5a4269: 'chang shang shou jianAddress:',
  auto_183_7d26588a: 'Express Company:',
  auto_184_4833177f: 'Select express company',
  auto_185_9a01a66f: 'Express No',
  auto_186_63c16dc2: 'Enter express no',
  auto_187_9b32ddbc: 'devicehui ji shou jian renName:',
  auto_188_fbfd4735: 'Enterdevicehui ji shou jian renName',
  auto_189_f1c2c6f8: 'devicehui ji shou jian renPhone Number:',
  auto_190_5dc58112: 'Enterdevicehui ji shou jian renPhone Number',
  auto_191_0e819a56: 'Label:',
  auto_191_a87f2af7: 'devicehui ji shou jianAddress:',
  auto_192_6864fd19: 'Select province/city/district',
  auto_193_04ebeeef: 'xxshengxxshixxquxxjie daoxxhao',
  auto_194_0b4ed967: 'textProcesstext:',
  auto_195_04d273c0: 'Select after-sales method',
  auto_196_af1d4694: 'gei jia zhang deNew DeviceSN Code:',
  auto_197_58238cdc: 'Enter new machine SN:',
  auto_198_d201175c: 'ReadFault description:',
  auto_199_058a9250: 'Agree',
  auto_200_eab01883: 'Label',
  auto_201_cc0c52e0: 'ben diFileUpload',
  auto_202_cfbe45e7: 'pai sheImageVideo',
  auto_203_47c45527: 'Suggested Handling Method',
  auto_204_c403a5e0: 'Select suggested handling method',
  auto_205_d8e5327e: 'Initial Diagnosis Processing Method',
  auto_206_802db140: 'Label',
  auto_207_73349dba: 'Actual Processing Method',
  auto_208_7f46aae8: 'Label',
  auto_209_7a3032f3: 'Label',
  auto_210_c7bb407f: 'Actual fault type',
  auto_211_9123b491: 'Select fault classification',
  auto_212_71196810: 'Test description',
  auto_213_c905215d: 'EnterInspection Result400zi yi nei',
  auto_214_788c4e7e: 'Inspection Result',
  auto_215_a3a60d9e: 'Inspection ImageVideo',
  auto_216_fda9439e: 'Upload ImageVideo',
  auto_73_70dbabd2: 'textbb',
  auto_126_833d3bf7: 'Video Call ServiceNot Activated',
  auto_127_da19ce81: 'Video Call ServiceActivated',
  auto_128_f729d6ba: 'This payment will deduct',
  auto_129_0d59f21f: 'Cash Account',
  auto_130_7fe93f55: 'Remaining Payment',
  auto_131_8d1457b5: 'Pay Method',
  auto_132_315490d7: 'CancelCloseVideo Call Service',
  auto_132_b843f6aa: 'min',
  auto_133_1c97f68c: 'shi fou yao kai qiAuto Renewkai qi hou fu wu dao qi jiang hui zi dong jin xing xu fei',
  auto_133_d5a9ecd5: 'Call Staff Name',
  auto_134_caf9ef8b: 'Call StaffAccount',
  auto_134_d87a1bfe: 'CloseVideo Call Service',
  auto_135_aa966d94: 'shi fou xu yaoClose Auto RenewalClosehou fu wu dao qi jiang bu huiAuto Renew',
  auto_135_c3004cf6: 'Call Time',
  auto_136_8b21a30d: 'Open Video Call Service',
  auto_136_f63b4da6: 'Call Start Time',
  auto_137_d7353e2e: 'Call End Time',
  auto_138_06fe2370: 'Call Duration',
  auto_217_0b79ebf8: 'ReadFault description',
  auto_218_bde87180: 'Agree',
  auto_219_0d425989: 'Label',
  auto_221_4fe609e4: 'ben diFileUpload',
  auto_222_a26baab5: 'pai sheImageVideo',
  auto_223_0fdb1e9c: 'Suggested Handling Method',
  auto_224_6d36bd59: 'Select suggested handling method',
  auto_225_eac1b90f: 'Initial Diagnosis Processing Method',
  auto_226_281830e2: 'Select first diagnosis method',
  auto_227_4de236d6: 'Initial diagnosis description',
  auto_228_a0a2b7b5: 'EnterInitial diagnosis description400zi yi nei',
  auto_229_b388a4cb: 'Initial diagnosis result',
  auto_230_79138e95: 'yu jiFinish Time',
  auto_231_89c25eb2: 'Initial diagnosis imageVideo',
  auto_232_0ecfdfec: 'Factory Return Express Information',
  auto_233_410a70dc: 'Upload ImageVideo',
  auto_234_b92bb886: 'Save',
  auto_344_bb55a52a: 'Agree',
  auto_345_0957f1aa: 'Label',
  auto_346_0908e2d5: 'ben diFileUpload',
  auto_347_15d41886: 'pai sheImageVideo',
  auto_348_f9768426: 'Actual Processing Method',
  auto_349_cc32882e: 'Label',
  auto_350_f2fc58e4: 'Actual fault type',
  auto_351_0e2c4c06: 'Select fault classification',
  auto_352_98d4b1ac: 'Return Result',
  auto_353_0a993491: 'Express Company',
  auto_354_199b57b5: 'Select express company',
  auto_355_e23b1694: 'Express No.',
  auto_356_19d6bce9: 'Enter express no.',
  auto_357_7d0cefcc: 'Return imagesVideo',
  auto_358_85225a33: 'Upload ImageVideo',
  auto_163_2f65a87d: 'Repair RequestCreate',
  auto_164_b1ee144c: 'Repair RequestEdit',
  auto_165_9314da58: 'Repair RequestReview',
  auto_166_d7b2c0e5: 'Repair RequestReturn shipping',
  auto_167_e572d148: 'Repair RequestRepair result',
  auto_168_60062016: 'Repair RequestDetail',
  auto_169_16249d57: 'Repair RequestInitial Diagnosis',
  auto_170_1f52a8fc: 'Repair RequestQuality inspection',
  auto_171_66f61756: 'Repair RequestReturn Express',
  auto_172_d902028a: 'Repair RequestReinspection result',
  auto_173_10a54dad: 'Repair RequestDispute result',
  auto_174_809ab92b: 'Repair RequestDetection',
  auto_175_f63053de: 'Repair RequestFill in quote',
  auto_176_98a3a89c: 'Repair RequestRepair payment',
  auto_277_c6c3e0e3: 'Agree',
  auto_278_4d987287: 'Label',
  auto_279_0c5e2bee: 'ben diFileUpload',
  auto_280_a435f985: 'pai sheImageVideo',
  auto_281_d8d42434: 'Actual Processing Method',
  auto_282_12e37cb8: 'Label',
  auto_283_a0c37874: 'Inspection ImageVideo',
  auto_284_493a8502: 'Quality inspectionjie guo',
  auto_285_fffa3009: 'Quality inspectionRemark',
  auto_286_1b5ad69d: 'Enter quality check remark400zi yi nei',
  auto_287_3425dcf8: 'Quality Inspection ImageVideo',
  auto_288_acbdb7f8: 'Upload ImageVideo',
  auto_2_20f54b4b: 'text2us',
  auto_067_7601e4b2: 'textb',
  auto_289_7cb946ef: 'Add repair detail',
  auto_292_544a569b: 'ReadFault description',
  auto_298_9b7d5cf3: 'Actual Processing Method',
  auto_299_6bf44d2b: 'Select actual handling method',
  auto_300_15efe189: 'Actual fault type',
  auto_301_c4f93f5e: 'Select fault classification',
  auto_302_7e3fa6d5: 'Non-warranty reason',
  auto_735_65180f3b: 'textg',
  auto_916_2233ebaf: 'textk',
  auto_427_942e6019: 'Pass',
  auto_428_d0383398: 'Long term',
  auto_429_92e861db: 'Short term',
  auto_430_947eb541: 'Long term',
  auto_431_4c90514a: 'Short term',
  auto_432_e0aaf07a: 'Report',
  auto_433_72267377: 'Report',
  auto_434_edc2c553: 'Track',
  auto_435_fbe7801b: 'Track',
  auto_436_69c3e358: 'Pass',
  auto_437_ad9a62b2: 'Page sizeFrontend hardcoded firstshi ji',
  auto_333_0ac5f60b: 'Effective foundation study time in last 180 days (hours)',
  auto_334_b6f21e2a: 'Knowledge gaps closed in last 180 days (foundation)',
  auto_335_a582cb25: 'Student score improvement in last 180 days',
  auto_336_fb423e6d: 'First exam score in last 180 days',
  auto_337_6fc65c2a: 'Latest exam score in last 180 days',
  auto_338_2f7b8451: 'Score change from first to last exam (180 days)',
  auto_339_31f360f4: 'Average score improvement (180 days)',
  auto_340_5a440d46: 'Score stability in last 180 days',
  auto_341_4b651596: 'Average exam score (180 days)',
  auto_342_225d514e: 'Score standard deviation (180 days)',
  auto_509_28f98467: 'jin180Daily Student Score Improvement Analysis',
  auto_116_7aaa417f: 'All',
  auto_117_3cc991a0: 'Label',
  auto_118_c9074fd5: 'Label',
  auto_119_64538f3b: 'Stage/Grade',
  auto_120_7ac3b736: 'Course',
  auto_121_4d27f7b6: 'Copy Link',
  auto_122_1e53b582: 'View Report',
  auto_123_7fd832fc: 'undefined',
  auto_124_d08c864a: 'Please select stage first',
  auto_125_f9c29978: 'Please select course',
  auto_6003001_02a744ab: 'stageGrade',
  auto_6003002_877902ff: 'stageGrade',
  auto_6003003_364f8301: 'stageGrade',
  auto_6004001_e10db50f: 'stageGrade',
  auto_6004002_0865167a: 'stageGrade',
  auto_6004003_b91584c0: 'stageGrade',
  auto_6004004_5b8f673d: 'stageGrade',
  auto_6004005_54bfd328: 'stageGrade',
  auto_6004006_6df46f26: 'stageGrade',
  auto_6004007_0cb97568: 'stageGrade',
  auto_6004008_8cb729ce: 'stageGrade',
  auto_6004009_67a799aa: 'stageGrade',
  auto_6004013_061a6c58: 'stageGrade',
  auto_234_3cfbcbdf: 'textProcesstext',
  auto_235_df8798a9: 'Select after-sales method',
  auto_236_b492118c: 'gei jia zhang deNew DeviceSN Code',
  auto_237_60e436d2: 'Enter new machine SN',
  auto_238_88c9b290: 'Suggested Handling Method',
  auto_239_572dbdf7: 'Select suggested handling method',
  auto_240_107ef516: 'Actual Processing Method',
  auto_241_c0807481: 'Select actual handling method',
  auto_242_a36f8021: 'sNma',
  auto_243_e3477f5f: 'Enter SN code',
  auto_203_959b08b8: 'Please selectping fen',
  auto_204_38baf24a: 'Label',
  auto_205_a42c243e: 'Label',
  auto_206_317e891f: 'Label',
  auto_207_a2abe9ff: 'Label',
  auto_208_bf9129ea: 'Label',
  auto_209_1ad3f865: 'Label',
  auto_486_d6b480e5: 'Label',
  auto_487_007ca415: 'Submit',
  auto_488_b29e261f: 'Evaluate',
  auto_123_829cdda3: 'shou gongFoundation',
  auto_124_9ab01fc5: 'xi tongFoundation',
  auto_125_42965969: 'feiFoundation',
  auto_126_ac871dbb: 'Regular Course',
  auto_127_96e51db7: 'Downgrade',
  auto_128_f01e330d: 'Other',
  auto_129_74e0f116: 'Formal course retake',
  auto_130_dc39f9ac: 'Foundation upgrade',
  auto_131_4c4eca8d: 'Foundation Building Retake',
  auto_156_87c3f69b: 'Operation Time',
  auto_157_209fc4d7: 'Supervisor Status',
  auto_158_1ae39484: 'Analyst',
  auto_159_2e809b36: 'Supervisorkai shi',
  auto_160_b408bfc4: 'Supervisor Study End',
  auto_161_b49a624a: 'Operator',
  auto_162_2f0acc05: 'Remark',
  auto_192_47a2745e: 'No data',
  auto_465_e4f28096: 'New DeviceSN Code',
  auto_466_417ab7f4: 'Initial diagnosis imageVideo',
  auto_467_212fe736: 'Inspection ImageVideo',
  auto_468_70d1a468: 'Quality Inspection ImageVideo',
  auto_469_6e3e8cfa: 'Return imagesVideo',
  auto_411_f630a136: 'Repair Quotation',
  auto_470_b4b3c003: 'text2text',
  auto_471_ce1859e8: 'Customer ID',
  auto_472_e66c9649: '1Please in2ge gong zuo ri neiPaymentOtherwise Original Device Will Be Considered Not RepairedReturn original machine unrepaired',
  auto_473_6a6a65c2: '2Due toque jian huo jin quan li shang bu neng xiu fu shiWill Refund Original Repair PaymentBut Assume No Other Responsibilities',
  auto_474_919d675a: '3wei xiu haoMachinezi tong zhi zhi ri qiOur Repair Center Provides Free Storage for You1Month(s)yu qi bu qu',
  auto_294_bccbd499: 'stageGrade',
  auto_303_55d157e8: 'stageGrade',
  auto_305_05bf4e85: 'servicePerson',
  auto_459_edcab6b9: 'Apply Transfer to Service Center',
  auto_460_635091c6: 'Adaptive Account',
  auto_461_42ffa4f6: 'Enter adaptive account',
  auto_462_77ac7212: 'User Name',
  auto_463_866ca1be: 'xianService Center ID',
  auto_464_b6bc3e36: 'xianService Center Name',
  auto_376_21af678e: 'Mathematics',
  auto_377_4bc8c6b9: 'All',
  auto_378_087b51d3: 'StudentStudy Durationri bao',
  auto_495_019f0951: 'Supervisor Status',
  auto_496_a098bf4b: 'Supervisor Status',
  auto_497_af42befc: 'Data note: Data may be delayed by up to 1 hour. For data definitions, please go to Help Center.',
  auto_452_0ffc43ee: 'Label',
  auto_453_5d03913f: 'Call Duration',
  auto_454_c079befc: 'Label',
  auto_455_c641fa42: 'Call Duration',
  auto_456_f0368aa0: 'Cash Account',
  auto_457_055f7a2e: 'remainingPayment',
  auto_458_256c6775: 'Pay Method',
  auto_1_30bb9873: 'checkFaceChangeLearningMachine',
  auto_2_905c20d8: 'checkFaceChangeLearningMachine',
  auto_3_3c8a512d: 'checkFaceChangeLearningMachine',
  auto_12_b0263010: 'Service Center',
  auto_13_3e7b680b: 'Label',
  auto_14_87909680: 'Service CenterAccount Management',
  auto_502_1e1de5f1: 'Modify Area',
  auto_503_51e1995f: 'Freezehou gaiaccountnei deSubscribeshi chang jiang wu faUse',
  auto_101_e2aedd75: 'Operation Time',
  auto_102_951961f3: 'Operation type',
  auto_103_bd53e7e8: 'Operator',
  auto_104_d8c791af: 'Gold coinsshu',
  auto_105_e9a92572: 'Remark',
  auto_475_0bccafc0: 'Out-of-warranty repair requires feePlease go to Service Center - Repair Management',
  auto_476_e3048df8: 'Repair payment',
  auto_477_231a7700: 'Requires Out-of-warranty RepairOut-of-warranty repair requires feePleaseService Centeryi',
  auto_478_d99e06c9: 'Repair managementyi',
  auto_479_7f349b2d: 'Repair payment',
  auto_253_3b43b9b0: 'Label',
  auto_254_8a43e66e: 'sheng chengImageFailed',
  auto_489_ddfa90d4: 'yi bao studentsming dan',
  auto_490_afc260cf: 'Activity Rules',
  auto_491_6e4b2373: 'Viewpai ming',
  auto_380_0eae7322: 'Mathematics',
  auto_381_881fe582: 'All',
  auto_382_53fb76b8: 'StudentStudy Durationzhou bao',
  auto_383_e6592468: 'All',
  auto_512_8a1c00e3: 'Supervisor Status',
  auto_7_24eae4ed: 'Monthly Quota Not Exceeded',
  auto_8_2f854118: 'Your Cross-entity Device Student Has',
  auto_9_d59fe97e: 'No Need to Apply in Current Status',
  auto_499_ce0718ea: 'Detail',
  auto_1_af66dc5d: 'Subscribe Subject Management',
  auto_2_1c595e87: 'Unbind',
  auto_3_7ef232fe: 'Submit Materials',
  auto_4_848fbce8: 'Withdraw Application',
  auto_5_971e3864: 'Unsubscribe Effective',
  auto_6_5b16954e: 'Unsubscribe',
  auto_7_4bc804a5: 'Subscribe',
  auto_8_0518f833: 'Unsubscribe Effective',
  auto_9_5429858c: 'proofUploadTip',
  auto_11_2204ab70: 'save',
  auto_12_a5aabedb: 'confirmUnsubscribe',
  auto_13_c9216b74: 'confirmWithdrawApply',
  auto_14_3c96af6d: 'Confirm to unbind?',
  auto_15_306787ed: 'confirmUnbind',
  auto_15_35381be3: 'Cancel Unsubscribe',
  auto_16_c75582a9: 'Unsubscribe',
  auto_16_fc574e73: 'Operation',
  auto_17_019f198f: 'Subscribe Subject Management',
  auto_17_f2e61b71: 'Subscribe',
  auto_18_09bd5a0c: 'Subscribe Confirm',
  auto_18_bf0e2367: 'studentAccount',
  auto_19_057b7f8e: 'Cancel Subscribe',
  auto_19_5502194f: 'studentName',
  auto_20_1169bd4a: 'Subject for this subscription:',
  auto_20_87832da3: 'serviceCenterId',
  auto_21_92f76fe3: 'serviceCenterName',
  auto_21_d819bfd8: 'Subject for this cancellation:',
  auto_22_71a84be6: 'machineAccount',
  auto_22_ca836920: 'Subscription duration to deduct:',
  auto_23_5eccdf82: 'learningArea',
  auto_23_67c3b1f5: 'Subscription duration to return:',
  auto_24_be4e3997: 'generalAvailableDuration',
  auto_24_cfa4dd68: 'month',
  auto_25_863b5b8e: 'areaDuration',
  auto_26_c4eea0dc: 'agentId',
  auto_27_d2bf4fe8: 'agentName',
  auto_28_c95c1bcf: 'Subject',
  auto_29_13d755f8: 'Machine Subscribe Status',
  auto_30_6dc1caf9: 'Recent Subscribe/Cancel Date',
  auto_31_6c5829a0: 'Current Study End Date',
  auto_32_de56ac7d: 'Operation',
  auto_33_a236e8ce: 'submitMaterial',
  auto_34_a3e39357: 'machineAccount',
  auto_35_06c71e3d: 'dealerId',
  auto_36_7fe79402: 'dealerName',
  auto_37_efc28e26: 'studentAccount',
  auto_38_5dc15e20: 'studentName',
  auto_39_981a562a: 'serviceCenterId',
  auto_40_71354afd: 'serviceCenterName',
  auto_41_9920dff0: 'applicationNote',
  auto_42_db2651d9: 'newStudentName',
  auto_43_ff2ef6b5: 'newStudentFacePhoto',
  auto_44_22854a73: 'proofMaterial',
  auto_45_0070c41a: 'studentAccount',
  auto_46_c38e83ce: 'studentName',
  auto_47_3f310da6: 'machineAccount',
  auto_48_9304b4af: 'agentId',
  auto_49_6bfd048e: 'agentName',
  auto_110_f60501a2: 'slotTipStyleColorRedFontSize',
  auto_83_7c03422b: 'textaj',
  auto_412_fd56053a: 'Service PersonName',
  auto_413_f7669bb3: 'Last Edit Time',
  auto_414_057d9acb: 'Last Edited By',
  auto_507_3a10ccc6: 'Operation',
  auto_10_f6175120: 'Payment Success',
  auto_11_c0ec4324: 'Payment Failed',
  auto_505_7ee80f77: 'pi liangDownloadzheng shu',
  auto_3_7cdf040b: 'texteuq',
  auto_5_f178aefd: 'text7wz',
  auto_403_cfdb95d6: 'Subject',
  auto_404_df63901a: 'Machine Subscribe Status',
  auto_405_d42d266b: 'Currentjie zhiDate',
  auto_480_828e6717: '1. Whole machine replacement: The entire set (device, all accessories and packaging) must be returned together. If any accessories are missing, you will need to resend them at your own expense.',
  auto_481_a786a76b: '2. Shipping requirement: For devices within normal warranty, please use SF Express collect (select basic insurance of 1000). Other couriers are not accepted for collect shipping.',
  auto_482_e92ab4dc: '3. Please pack the device or accessories properly to avoid damage during transit. Damage caused by improper packaging will require paid repair.',
  texteg6t: 'Notes:',
  textkltr: 'Initial Diagnosis Reminder:',
  textoetj: 'Review Result:',
  text428g: 'Repair Vendor:',
  text58ht: 'Suggested Handling:',
  text13p1: 'Review Description:',
  auto_483_928fe8ab: '1Please mail device to service center. Contact info:',
  auto_484_966e41e2: '2After mailing, please go to Service Center - Repair Management',
  auto_485_ab50f737: 'Return shipping',
  auto_3_5e466813: 'Available subscription duration <= 3',
  auto_492_9435e1c2: 'Recharge Area Duration',
  auto_493_c261b541: 'Recharge Universal Duration',
  auto_494_f48698f1: 'Withdraw Application',
  auto_406_8bcdf4a4: "Important: To calculate and compare grade-wide results in a consistent and fair manner, before statistics on average score gain in the last 180 days, average exam score in the last 180 days, and score standard deviation in the last 180 days, each student's exam scores are converted using a standardization procedure to a unified 100-point scale.",
  auto_407_aa45471f: 'Overall Analysis of Student Score Improvement',
  auto_511_48a81cbb: 'Data descriptionshu juUpdatepin lv shiDailyzao shang9dianUpdateru xu liao jie shu ju ding yiPlease go to',
  auto_408_85cbea7f: 'Collapse',
  auto_409_c74e2fe2: 'Expand',
  auto_410_8f7838e4: "Important: To calculate and compare grade-wide results in a consistent and fair manner, before statistics on average score gain in the last 180 days, average exam score in the last 180 days, and score standard deviation in the last 180 days, each student's exam scores are converted using a standardization procedure to a unified 100-point scale.",
  auto_415_22dcce77: 'Please set query conditions first',
  auto_504_4f36b366: 'Export',
  auto_500_a828735f: 'Distribution Time is required. Other functions are available only after a distribution time is selected. Please select a distribution time within the current day range of one month.',
  auto_501_48092518: 'Export',
  auto_185800506_58c5517a: 'Log statistics start time: 2022-03-10 18:58:00',
  auto_1_165d48be: 'Contact 1:',
  auto_2_ab5a3c71: 'Contact 2:',
  auto_3_f3a61608: 'Contact 3:',
  auto_139_78a7474f: 'Pre-K',
  auto_6004020_9fb52f98: 'stageGrade',
  auto_6004024_56050475: 'stageGrade',
  auto_6004025_a2790b71: 'stageGrade',
  auto_426_67419378: 'No tracking info yet',
  auto_255_8cc3a952: 'customerName',
  auto_256_fb9dab74: 'phoneNumber',
  auto_258_881fdc8a: 'realNameAuth',
  auto_261_8ab57ee8: 'stageGrade',
  auto_263_bc2c70c1: 'passStatus',
  auto_264_588a1075: 'syncCourseStatus',
  auto_265_33c813d7: 'servicePerson',
  auto_266_b63501b3: 'learningMachineAccount',
  auto_267_b97ad3f6: 'area',
  auto_268_88e2a405: 'subscribeSubject',
  auto_281_90a430ff: 'math',
  auto_282_20150756: 'notHeld',
  auto_283_e9cbeeea: 'passHeld',
  auto_284_f3168d65: 'tempPassHeld',
  auto_285_e93fb901: 'notRecommended',
  auto_286_f3878e5a: 'learnable',
  auto_287_4ec7765a: 'notLearnable',
  auto_288_0278db73: 'Invite Transfer',
  auto_508_04104a66: 'batchAssignServicePerson',
  auto_510_3b232c96: 'Exportshu ju',
  auto_443_ba4c8a8b: 'Label',
  auto_438_62acb843: 'Load failed',
  auto_439_f1a47351: 'Chinese',
  auto_440_2d7949dd: 'English',
  auto_441_33ffd6ef: 'Chinese',
  auto_442_6f7a8f7e: 'English',
  auto_444_2f090940: 'Gift',
  auto_210000513_5078ee96: 'Log Statistics Start Time2022nian11yue21ri',
  auto_185800514_285eb524: 'Log Statistics Start Time2022nian3yue10ri',

  back: 'After mailing, please ',
  you: 'Fill in your shipping and return information on the page.',
  youbackyou: 'Thank you. Our after-sales team will process your request as soon as possible.',
  houryoubackyou:
    'choose whether to pay. If you have questions, contact customer service promptly. Thank you for your cooperation; our after-sales team will expedite handling.',
  youci: 'Are you satisfied with this repair service?',
  public: 'Courier company',
  long: 'Long-term',
  maintenanceExpressNo: 'Tracking no.',
  maintenanceQuotationTime: 'Quotation time',
  maintenanceProductModel: 'Product model',
  maintenancePdfPayTitle: 'Scan to pay',
  maintenanceConfirmTime: 'Confirmation time',
  text08wg: "回寄说明：",
  text2fmi: "维修金额合计：",
  text2rn0: "非保修原因：",
  text2v3y: "实际故障类型：",
  text3dfv: "Contact：",
  text3x2u: "客户电话：",
  text3yj8: "页面查看维修报价详情，并",
  text41ik: "Customer Name：",
  text4hjl: "复检结果：",
  text5k7h: "争议结果：",
  text638k: "复检备注：",
  text6of5: "维修明细：",
  text6psd: "联系地址：",
  text8mih: "报价结果：",
  texta79g: "实际故障类型：",
  textabwu: "回寄快递信息：",
  textauck: "Discount Amount：",
  textclfy: "返厂快递信息：",
  textcovx: "确认人签名：",
  texte6z6: "维修结果：",
  textekrr: "质检说明：",
  textf2fv: "初诊处理方式：",
  textf6jv: "回寄结果：",
  textg4ij: "初诊说明：",
  texthf21: "实际处理方式：",
  textkir1: "联系电话：",
  textla63: "维修金额合计：",
  textmku1: "维修明细：",
  textmp23: "故障图片：",
  textnsn7: "收件人信息：",
  textnuvo: "联系方式",
  textnv37: "初诊结果：",
  texto0ao: "检测结果：",
  texto7f9: "非保修原因：",
  textoy9p: "Original PriceTotal Amount：",
  textqvas: "争议说明：",
  textqzt0: "维修说明：",
  textrbae: "故障图片：",
  textropu: "报价说明：",
  textseap: "检测说明：",
  textt813: "尊敬的合作伙伴：",
  texttzem: "质检状态：",
  textu5s2: "尊敬的合作伙伴：",
  textucfs: "支付结果：",
  textwdoz: "厂商地址：",
  textx3h1: "报价说明：",
  textzcvk: "支付说明：",
}
};
